<template>
  <div v-if="pageSensor != null && isLoginUserItemReadable(this.pageSensor)">
    <sensorTabs :current="'graph'" :pageSensor="pageSensor" :pageDevice="pageDevice" :pageUser="pageUser">

      <b-button type="button" variant="warning" class="float-right tabButton" size="sm" v-if="showUpdateButton">
        <b-spinner small type="grow" class="mr-0"></b-spinner>
        새 데이터 반영중
      </b-button>

      <b-button type="button" variant="info" class="float-right tabButton mr-2" size="sm" @click="copyURL">
        주소복사
      </b-button>


    </sensorTabs>


    <div :class="(isLoginUserItemWritable(this.pageSensor))? 'writable pt-2':'notWritable pt-2'">

      <div v-if="isLoginUserItemWritable(this.pageSensor)">
        <b-alert class="m-0 mt-2 mb-2 p-1 pl-2 fontSizeDot9" show variant="danger" v-if="this.pageSensor.disabled == true || this.pageDevice.disabled == true">
          정지 중이므로 기기의 정보를 변경할 수 없습니다.
        </b-alert>
      </div>

      <div v-if="showScopeControl" id="scopeControl" class="border border-bottom-0 border-secondary-light m-0 p-0 fontSizeDot8 menuRow" style="grid-template-columns: auto 5.5rem;">

        <div style="grid-area: left;" class="gridAreaBorderRight p-1">
          <b-form @submit.stop.prevent class="was-validated">

              <b-button class="m-0 ml-1 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="previousScopeFromId" :disabled="sliderShow || scopeFromId <= 0 || scopeFromId == null" :title="(sliderShow || scopeFromId <= 0 || scopeFromId == null)? '': '이전'">
                &cularr;
              </b-button>

              <b-form-input v-touch:swipe.stop :number="true" v-model="scopeFromId" id="scopeFromId" type="number" required :min="0" :max="Math.min(sensorRowCount-1-1, scopeToId-1)" trim size="sm" class="pt-dot1 pr-dot1 pb-dot1 pl-dot1 d-inline-block border-secondary m-0 mr-dot1 fontSizeDot8 text-right" style="width: 4.5rem; height: 1.6rem; vertical-align: -1px; background-position: left calc(0.1rem) center !important;" v-b-tooltip.hover  :title="scopeFromIdDateStr" :disabled="sliderShow" @change="scopeFromIdChanged"/>

              <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="nextScopeFromId" :disabled="sliderShow || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || scopeFromId == null || (scopeFromIdStart+1000) >= scopeToId" :title="(sliderShow || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || scopeFromId == null || (scopeFromIdStart+1000) >= scopeToId)?'':'다음'">
                &curarr;
              </b-button>

              <b-button class="m-0 p-dot1 fontSizeDot8 d-inline-block" :variant="(scopeFromDateSelected)?'primary':'secondary'" size="sm" style="height: 1.6rem; width: 1.5rem;" @click="focusElement('scopeFromDate');" v-b-tooltip.hover :title="scopeFromDateStr" :disabled="sliderShow">
                &#128336;
              </b-button>

              <datetime v-model="scopeFromDate" ref="scopeFromDate" input-id="scopeFromDate" type="datetime" class="d-inline-block m-0 p-0" style="width: 0.5rem; height: 0.5rem;" input-class="m-0 p-0" input-style="width:1px; height: 10px; font-size: 1px; display: inline-block; opacity: 0;"	value-zone="local" zone="local" format="yy-LL-dd T" :phrases="{ok: '계속', cancel: '취소'}" :minute-step="1" :week-start="7" auto @input="scopeFromDateInput" :disabled="sliderShow" :min-datetime="minFromDate" :max-datetime="maxFromDate"></datetime>

              <span class="m-0 font-weight-bold d-inline-block">
                ~
              </span>

              <datetime v-model="scopeToDate" ref="scopeToDate" input-id="scopeToDate" type="datetime" class="d-inline-block m-0 p-0" style="width: 0.5rem;" input-class="m-0 p-0" input-style="width:1px; height: 10px; font-size: 1px; display: inline-block; opacity: 0;"	value-zone="local" zone="local" format="yy-LL-dd T" :phrases="{ok: '계속', cancel: '취소'}" :minute-step="1" :week-start="7" auto @input="scopeToDateInput" :disabled="sliderShow"></datetime>

              <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="previusScopeToId" :disabled="sliderShow || scopeToId <= 0 || scopeToId == null || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || (scopeToId-1000)<= scopeFromId" :title="(sliderShow || scopeToId <= 0 || scopeToId == null || Math.floor(scopeFromId/1000) >= Math.floor(scopeToId/1000) || (scopeToId-1000)<= scopeFromId)? '':'이전'">
                &cularr;
              </b-button>

              <b-form-input v-touch:swipe.stop :number="true" v-model="scopeToId" id="scopeToId" trim type="number" required :min="scopeFromId*1+1" :max="sensorRowCount-1" size="sm" class="pt-dot1 pr-dot1 pb-dot1 pl-dot1 d-inline-block border-secondary m-0 mr-dot1 fontSizeDot8 text-right" style="width: 4.5rem; height: 1.6rem; vertical-align: -1px; background-position: left calc(0.1rem) center !important;" v-b-tooltip.hover :title="scopeToIdDateStr" :disabled="sliderShow" @change="scopeToIdChanged"/>

              <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block displayNoneMax589" variant="secondary" size="sm" style="height: 1.6rem; width: 1.2rem;" @click="nextScopeToId" :disabled="sliderShow || scopeToId >= (sensorRowCount-1) || scopeToId == null"  :title="(sliderShow || scopeToId >= (sensorRowCount-1) || scopeToId == null)?'':'다음'">
                &curarr;
              </b-button>

              <b-button class="m-0 mr-dot1 p-dot1 fontSizeDot8 d-inline-block" :variant="(scopeToDateSelected)?'primary':'secondary'" size="sm" style="height: 1.6rem; width: 1.5rem;" @click="focusElement('scopeToDate')" v-b-tooltip.hover :title="scopeToDateStr" :disabled="sliderShow">
                &#128336;
              </b-button>

              <b-button :disabled="pageSensor.lastBook >= 200 || pageSensor.lastBook < 2" class="m-0 ml-dot1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block displayNoneMax589" variant="primary" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="toggleSliderShow" v-b-tooltip.hover :title="(sliderShow)? '범위 슬라이드 닫기':'범위 슬라이드 열기'">
                <span v-if="sliderShow">&wedgeq;</span>
                <span v-else>&veeeq;</span>
              </b-button>

              <b-button :disabled="scopeFromIdBook == 0" class="m-0 ml-1 p-dot1 fontSizeDot8 d-inline-block" variant="primary" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="moveScopeLeft" v-b-tooltip.hover title="범위 왼쪽으로 이동">&lt;</b-button>

              <b-button :disabled="scopeToIdBook == pageSensor.lastBook" class="m-0 ml-1 p-dot1 fontSizeDot8 d-inline-block" variant="primary" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="moveScopeRight" v-b-tooltip.hover title="범위 오른쪽으로 이동">&gt;</b-button>

          </b-form>
        </div>

        <div v-if="dataUpdateNeeded & tinkOptions._tinkDataReady" style="grid-area: right;" class="p-1 text-center">

          <b-button class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 d-inline-block fontSizeDot8" style="height: 1.6rem;" variant="danger" size="sm" @click="applyScopeChanged" v-b-tooltip.hover title="변경된 범위를 적용">
            적용
          </b-button>

          <b-button class="m-0 mr-1 pl-1 pr-1 pt-dot1 pb-dot1 d-inline-block fontSizeDot8 text-right" style="height: 1.6rem;" variant="secondary" size="sm" @click="cancelScopeChanged" v-b-tooltip.hover title="변경된 범위를 취소">
            취소
          </b-button>

        </div>
      </div>

      <div v-if="showScopeControl && sliderShow && pageSensor.lastBook < 200" v-touch:swipe.stop class="fontSizeDot7 gothic mt-0 border border-bottom-0 border-secondary-light bg-secondary-lighter" :style="(pageSensor.lastBook < 10)? 'padding: 3rem 2.5rem 1.7rem 2.5rem;' : 'padding: 0.6rem 1.7rem 1.8rem 1rem;'">
        <vue-slider v-touch:swipe.stop ref="slider" v-model="sliderValues" :enable-cross="false" :min="-1" :max="this.sensorRowCount-1" :marks="true" :tooltip="(pageSensor.lastBook < 10)?'always':'none'" :dotSize="(pageSensor.lastBook < 10)? 20: 7" style="postion:relative;" :data="sliderStep" absort="true" :lazy="false" @change="checkSliderValues">
          <template v-slot:tooltip="{ value }">
            <div class="dataScopeToolTip">{{ getDateRow(value) }}</div>
          </template>
          <template v-slot:label="{ active, value }">
            <div :class="['vue-slider-mark-label', 'dataScopeSliderMark',{active}]">
              {{ getLabel(value) }}
            </div>
          </template>
        </vue-slider>
      </div>

      <div v-if="showSubControl" id="subControl" class="menuRow border border-bottom-0 border-secondary-light gothic m-0 fontSizeDot9" style="grid-template-columns: auto auto;">

        <div style="grid-area: left;" class="p-0">

          <div class="gridAreaBorderRight rounded-0 d-inline-block p-1 pl-2">
            <span style="vertical-align : -2px;" class="mr-1 displayNoneMax589">그룹</span>
            <b-form-select size="sm" v-model="groupBy" style="width: 3.3rem; height: 1.6rem;" class="pt-dot1 pb-dot1 pl-1 pr-1 m-0 mr-1 ml-1 fontSizeDot8 d-inline-block border-secondary rounded-0" :options="groupByOptions" @change="checkGroupBy" :disabled="!tinkOptions._tinkDataReady"></b-form-select>
          </div>

          <div v-if="groupBy == 'default'" class="gridAreaBorderRight rounded-0 d-inline-block p-1">
            <b-form-checkbox-group v-model="columns.default" id="columnsDefault" size="sm" class="pl-dot1 pr-dot1 pb-0 pt-0 fontSizeDot8 font-weight-bold d-inline-block" @change="applyColumnsSelected"  :disabled="!tinkOptions._tinkDataReady">
              <b-form-checkbox v-for="(value, name) in columnsOptions.default" :key="name" :value="name" size="sm" :style="'color:'+ tinkOptions._colorList[value.index].average">
                {{ value.text }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </div>

          <div v-else class="gridAreaBorderRight rounded-0 d-inline-block p-1">
            <div class="d-inline-block" v-for="(value, name) in valuesFiltered" :key="name">
              <b-dropdown size="sm" variant="outline-light" toggle-class="pt-dot1 pb-dot1 pl-1 pr-1 m-0 ml-dot1 mr-dot1 fontSizeDot8 d-inline-block border-secondary rounded-0" :disabled="!tinkOptions._tinkDataReady">
                <template #button-content>
                  <span style="color: black; letter-spacing: -1px;">
                    {{value.title}}<span v-if="columns[groupBy][value.name].length !=0">: </span>
                    <span v-for="(type, index) in columns[groupBy][value.name]" :key="type">
                      <span v-if="index !=0" style="letter-spacing: -1px;">, </span>
                      <span class="font-weight-bold" :style="`color: ${tinkOptions._colorList[columnsOptions[groupBy][value.name][type].index][type]}`">
                        {{valueTypeList[type].text}}
                      </span>
                    </span>
                  </span>
                </template>

                <b-form-checkbox-group v-model="columns[groupBy][value.name]" stacked class="p-1 fontSizeDot8" @change="applyColumnsSelected">
                  <b-form-checkbox v-for="(item, name) in columnsOptions[groupBy][value.name]" :key="name" :value="name" size="sm" :style="'color:'+ tinkOptions._colorList[item.index][typeOptions[item.typeIndex].value]">
                    {{ item.text }}
                  </b-form-checkbox>
                </b-form-checkbox-group>

              </b-dropdown>
            </div>
          </div>
        </div>

        <div style="grid-area: right; justify-self: end;" class="p-0">
          <div class="gridAreaBorderLeft rounded-0 d-inline-block p-1 pl-2 pr-2">
            <span class="fontSizeDot8 gothic" v-if="this.zoomLevel != 1" style="vertical-align:-2px">
              {{Math.round(this.roundValue(this.zoomLevel,2)*100)}}%
            </span>
            <b-button class="m-0 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block" variant="primary" size="sm" style="height: 1.6rem;width: 1.5rem;" @click="toggleZoom(!tinkOptions._tinkZoomEnabled)" :disabled="(zoomLevel == 1&&tinkOptions._tinkZoomEnabled)||!tinkOptions._tinkDataReady">
              <span v-if="!tinkOptions._tinkZoomEnabled">&plusmn;</span>
              <span v-else>&rlarr;</span>
            </b-button>
            <b-button class="m-0 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block" variant="danger" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="zoomIn" v-if="tinkOptions._tinkZoomEnabled" :disabled="zoomLevel<=0.01||!tinkOptions._tinkDataReady">
              +
            </b-button>
            <b-button class="m-0 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block" variant="danger" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="zoomOut" v-if="tinkOptions._tinkZoomEnabled" :disabled="zoomLevel==1||!tinkOptions._tinkDataReady">
              -
            </b-button>
            <b-button class="m-0 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block" variant="danger" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="panLeft" v-if="!tinkOptions._tinkZoomEnabled" :disabled="zoomLevel==1||!tinkOptions._tinkDataReady">
              &Lang;
            </b-button>
            <b-button class="m-0 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block" variant="danger" size="sm" style="height: 1.6rem; width: 1.4rem;" @click="panRight" v-if="!tinkOptions._tinkZoomEnabled" :disabled="zoomLevel==1||!tinkOptions._tinkDataReady">
              &Rang;
            </b-button>
            <b-button class="m-0 ml-1 pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8 d-inline-block" variant="primary" size="sm" style="height: 1.6rem; width: 1.5rem;" @click="resetZoom" :disabled="zoomLevel == 1||!tinkOptions._tinkDataReady">
              &orarr;
            </b-button>
            <!--
            {{this.tinkOptions._tinkScaleXMin}}~{{this.tinkOptions._tinkScaleXMax}} /
            {{this.tinkOptions._tinkScaleXOriginalMin}}~{{this.tinkOptions._tinkScaleXOriginalMax}} /
            {{zoomLevel}}
            -->

            <b-button class="m-0 ml-1 d-inline-block" variant="info" size="sm" style="padding: 0px; font-size: 1.1rem; height: 1.6rem; width: 1.6rem;" v-b-tooltip.hover title="차트 설정하기" v-b-modal.configGraphFloatModal
            >
            &#9881;
          </b-button>
          </div>
        </div>
      </div>

      <div id="chartBox" class="border" style="border-color: #dee2e6;">
        <div id="chartMessage" style="position:absolute;background:rgba(255,255,255,0.6)" :class="(!tinkOptions._tinkDataReady)? 'gothic text-primary p-5 font-weight-bold d-block': 'gothic text-primary p-5 font-weight-bold d-none'">
          <b-spinner small type="grow" variant="primary" class="mr-0"></b-spinner>
          <span class="pl-2 pr-2">Loading</span>
          <b-spinner small type="grow" variant="primary" class="mr-0"></b-spinner>
        </div>
        <div id="canvasBox" :style="canvasBoxStyle" class="overflowScrolllMax589">
          <canvas id="tinkChart"></canvas>
        </div>
      </div>

    </div>

    <b-modal v-touch:swipe.stop size="md" id="urlWithOptionsModal" tabindex="-1" title="현재 그래프 옵션을 포함한 주소" static header-bg-variant="info" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">
      <p>
        <b-form-textarea v-touch:swipe.stop rows="10" v-model="urlWithOptions" max-rows="20"></b-form-textarea>
      </p>
    </b-modal>

    <b-modal v-touch:swipe.stop size="lg" id="configGraphFloatModal" tabindex="-1" title="그래프 설정하기" static @show="modalShowFocus" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

      <p class="fontSizeDot9 gothic mt-dot1 ml-dot1 mr-dot1 mb-1 p-0" style="line-height: 190%;">
        그래프 설정은 [센서 저장 설정], [내 기본 설정], [기본 설정] 순서로 우선 적용됩니다.
        <span v-if="pageSensor.chartOptions">
          <b-button size="sm" variant="primary" class="pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8" style="vertical-align: 1px;" @click="loadChartConfig('sensor')">현재 센서에 저장된 설정</b-button>,
        </span>
        <span v-if="isLoginUserPageUser && loginUser.chartOptions">
          <b-button size="sm" variant="outline-primary" class="pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8" style="vertical-align: 1px;" @click="loadChartConfig('user')">내 기본 설정</b-button>,
        </span>
        <b-button size="sm" variant="secondary" class="pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8" style="vertical-align: 1px;" @click="loadChartConfig('default')">기본 설정</b-button>,
        <b-button size="sm" variant="outline-secondary" class="pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8" style="vertical-align: 1px;" @click="loadChartConfig('performance')">성능 우선 설정</b-button>을 불러와서 수정할 수도 있습니다. 그리고, <b-button size="sm" variant="info" class="pt-dot1 pb-dot1 pl-1 pr-1 fontSizeDot8" style="vertical-align: 1px;" @click="copyURLWithOptions">현재 그래프 옵션을 포함한 주소</b-button>를 복사할 수도 있습니다.
      </p>

      <b-form @submit.stop.prevent class="writable" v-if="editingOptions">
        <!--div class="mt-1 gothic gridColumn">
          <div class="gridColumnTitle">
            범위
          </div>
          <div class="gridColumnBody">
            <b>{{this.scopeFromId}}</b> ({{ this.scopeFromIdDateStr }})
            ~
            <b>{{ this.scopeToId}}</b> ({{ this.scopeToIdDateStr }})
          </div>
        </div-->


        <b-list-group squared class="text-left m-0 border-top-0 rounded-0">

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'basicConfig')">
                &dtrif; 기본 설정
            </div>

            <b-collapse id="basicConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1" :visible="true">

              <b-input-group size="sm" class="mt-1" v-if="editingOptions && editingOptions.layout">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="layoutPaddingConfig" style="margin-bottom : 0rem">안여백</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="layoutPaddingConfig" :number="true" v-model="editingOptions.layout.padding" type="number" min="0" max="50" v-b-tooltip.hover  title="그래프의 안쪽 여백의 크기입니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="canvasPaddingConfig" style="margin-bottom : 0rem">바깥여백</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="canvasPaddingConfig" :number="true" v-model="editingOptions._tinkCanvasMargin" type="number" min="0" max="50" v-b-tooltip.hover title="그래프의 바깥 여백의 크기입니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="presentationHeightResizeConfig" style="margin-bottom : 0rem">발표모드 높이(%)</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="presentationHeightResizeConfig" :number="true" v-model="editingOptions._tinkPresentationHeightResizePercent" type="number" min="0" max="500" v-b-tooltip.hover title="발표모드 그래프의 높이가 화면에 맞추어서 조절되는 최대 퍼센트입니다. 이 값을 0으로 지정하면 그래프가 항상 지정한 종횡비로 표시됩니다. 이 값을 50으로 지정하면 그래프의 높이가 화면에 맞게 -40%에서 +40%까지 조절됩니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="aspectRatioConfig" style="margin-bottom : 0rem">종횡비 (가로/세로)</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="aspectRatioConfig" :number="true" v-model="editingOptions.aspectRatio" type="number" min="0.5" max="5" v-b-tooltip.hover title="그래프 종횡비로 [가로 길이]/[세로 길이]로 지정합니다. 발표 모드에서는 그래프가 화면에 꽉차게 높이가 조정되므로 종횡비 설정이 무시됩니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="backgroundColorConfig" style="margin-bottom : 0rem">전체 배경색</label>
                </b-input-group-text>
                <b-form-input :style="'background-color:' + editingOptions._tinkBackgroundColor + ';'" v-touch:swipe.stop id="backgroundColorConfig" v-model="editingOptions._tinkBackgroundColor" type="text" required/>

                <b-button id="backgroundColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="backgroundColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="backgroudColorObject" @input="applyColor('backgroudColor')"></chrome-picker>
                </b-popover>
              </b-input-group>



            </b-collapse>
          </b-list-group-item>


          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'performanceConfig')">
                &dtrif; 단순 모드 설정
            </div>

            <b-collapse id="performanceConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="performanceAutoApplyConfig" style="margin-bottom : 0rem">단순 모드 전환 데이터 수</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="performanceAutoApplyConfig" :number="true" v-model="editingOptions._tinkPerformanceAutoApplyLength" type="number" min="5000" v-b-tooltip.hover  title="데이터 수가 지정된 값보다 크면 자동으로 그래프를  단순하게 표시합니다. 점, 말풍선이 표시되지 않고, 선의 장력, 애니매이션도 사라집니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="groupByAutoApplyConfig" style="margin-bottom : 0rem">그룹 모드 전환 데이터 수</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="groupByAutoApplyConfig" :number="true" v-model="editingOptions._tinkGroupByAutoApplyLength" type="number" min="10000" v-b-tooltip.hover  title="데이터 수가 지정된 값보다 크면 자동으로 데이터를 시간별, 일별, 월별 평균으로 단순하게 표시합니다." required/>
              </b-input-group>
            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'animationConfig')">
                &dtrif; 애니매이션 설정
            </div>

            <b-collapse id="animationConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">
              <b-input-group size="sm" class="mt-1" v-if="editingOptions.animation">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="animationDuration" style="margin-bottom : 0rem">지속시간(1/1000초)</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="animationDuration" :number="true" v-model="editingOptions.animation.duration" type="number" v-b-tooltip.hover title="애니메이션이 진행되는 시간을 1000분의 1초 단위로 지정합니다. 0으로 지정하면 전환효과 없이 바로 변경사항이 적용됩니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.animation">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="animationEasingConfig" style="margin-bottom : 0rem">애니매이션 움직임</label>
                </b-input-group-text>
                <b-form-select required id="animationEasingConfig" v-model="editingOptions.animation.easing" :options="[
                  'linear',
                  'easeInQuad',
                  'easeOutQuad',
                  'easeInOutQuad',
                  'easeInCubic',
                  'easeOutCubic',
                  'easeInOutCubic',
                  'easeInQuart',
                  'easeOutQuart',
                  'easeInOutQuart',
                  'easeInQuint',
                  'easeOutQuint',
                  'easeInOutQuint',
                  'easeInSine',
                  'easeOutSine',
                  'easeInOutSine',
                  'easeInExpo',
                  'easeOutExpo',
                  'easeInOutExpo',
                  'easeInCirc',
                  'easeOutCirc',
                  'easeInOutCirc',
                  'easeInElastic',
                  'easeOutElastic',
                  'easeInOutElastic',
                  'easeInBack',
                  'easeOutBack',
                  'easeInOutBack',
                  'easeInBounce',
                  'easeOutBounce',
                  'easeInOutBounce'
                ]" v-b-tooltip.hover title="애니메이션의 가속도 설정입니다. easeIn은 시작시, easeOut은 끝날 때를 뜻합니다. 다른 부분은 가속도 방식으로 https://easings.net/에서 자세한 내용을 살펴보세요.">
                </b-form-select>
              </b-input-group>

            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'pointConfig')">
                &dtrif; 데이터 점 설정
            </div>

            <b-collapse id="pointConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">
              <b-input-group size="sm" class="mt-1" v-if="editingOptions.elements && editingOptions.elements.point">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="elementsPointRadius" style="margin-bottom : 0rem">데이터 점 크기</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="elementsPointRadius" :number="true" v-model="editingOptions.elements.point.radius" type="number" min="0" max="10" v-b-tooltip.hover title="데이터를 나타내는 점의 크기입니다. 0으로 지정하면 점을 표시하지 않습니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.elements && editingOptions.elements.point">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="elementsPointHoverRadius" style="margin-bottom : 0rem">hover시 점 크기</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="elementsPointHoverRadius" :number="true" v-model="editingOptions.elements.point.hoverRadius" type="number" min="0" max="10" v-b-tooltip.hover title="점 위에 마우스를 올린 경우에 점의 크기입니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.elements && editingOptions.elements.point">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="elementsPointPointStyle" style="margin-bottom : 0rem">점의 모양</label>
                </b-input-group-text>
                <b-form-select required id="elementsPointPointStyle" v-model="editingOptions.elements.point.pointStyle" :options="[
                  'circle',
                  'cross',
                  'crossRot',
                  'dash',
                  'line',
                  'rect',
                  'rectRounded',
                  'rectRot',
                  'star',
                  'triangle'
                ]" v-b-tooltip.hover title="점의 모양입니다.">
                </b-form-select>
              </b-input-group>
            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'lineConfig')">
                &dtrif; 연결선 설정
            </div>

            <b-collapse id="lineConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">
              <b-input-group size="sm" class="mt-1" v-if="editingOptions.elements && editingOptions.elements.line">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="elementsLineBorderWidth" style="margin-bottom : 0rem">선 굵기</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="elementsLineBorderWidth" :number="true" v-model="editingOptions.elements.line.borderWidth" type="number" min="0" max="10" v-b-tooltip.hover title="점과 점을 연결하는 선의 굵기입니다. 0으로 지정하면 선을 그리지 않습니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.elements && editingOptions.elements.line">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="elementsLineTension" style="margin-bottom : 0rem">선의 장력</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="elementsLineTension" :number="true" v-model="editingOptions.elements.line.tension" min="0" max="2" v-b-tooltip.hover title="점과 점을 연결하는 선을 베지에(Bézier) 곡선으로 연결할 때 장력입니다. 0으로 지정하면 베지에 곡선 대신 꺽은 선을 사용하며 기본값은 0.1입니다. 너무 큰 값을 지정하면 연결선이 꼬일 수 있습니다." required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.elements && editingOptions.elements.line">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="elementsLineStepped" style="margin-bottom : 0rem">선 계단모양</label>
                </b-input-group-text>
                <b-form-select required id="elementsLineStepped" v-model="editingOptions.elements.line.stepped" :options="[
                  {value : true, text: '사용'},
                  {value : false, text: '사용 안함'},
                ]" v-b-tooltip.hover title="점과 점을 직접 연결하지 않고 계단으로 연결할 지 여부. 사용으로 지정하면 선의 장력 옵션은 무시합니다.">
                </b-form-select>
              </b-input-group>
            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'interactionConfig')">
                &dtrif; 말풍선 설정
            </div>

            <b-collapse id="interactionConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">
              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipEnabled" style="margin-bottom : 0rem">말풍선(Tooltip) 사용</label>
                </b-input-group-text>
                <b-form-select required id="tooltipEnabled" v-model="editingOptions.plugins.tooltip.enabled" :options="[
                  {value : true, text: '사용'},
                  {value : false, text: '사용 안함'},
                ]" v-b-tooltip.hover title="사용으로 지정하면 점에 마우스를 올리면 해당 점의 데이터 말풍선을 표시합니다.">
                </b-form-select>
              </b-input-group>


              <b-input-group size="sm" class="mt-1" v-if="editingOptions.events">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="interactionEvents" style="margin-bottom : 0rem">말풍선 이벤트</label>
                </b-input-group-text>
                <b-dropdown size="sm" toggle-class="p-0 m-0 fontSizeDot8 border-secondary rounded-0" class="form-control p-0 m-0" variant="secondary-light" v-b-tooltip.hover title="말풍선을 표시하는 이벤트를 선택합니다.">
                  <template #button-content>
                      {{editingOptions.events.join(", ")}}
                  </template>
                  <b-form-checkbox-group v-model="editingOptions.events" stacked class="p-1 pl-3 fontSizeDot8">
                    <b-form-checkbox variant="primary" v-for="value in interactionEventsList" :key="value" :value="value" size="sm">
                      {{value}}
                    </b-form-checkbox>
                  </b-form-checkbox-group>
                </b-dropdown>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.interaction">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="interactionMode" style="margin-bottom : 0rem">말풍선 내용</label>
                </b-input-group-text>
                <b-form-select required id="interactionMode" v-model="editingOptions.interaction.mode" :options="[
                  {value : 'point', text: '근처의 점들'},
                  {value : 'nearest', text: '가장 가까운 점'},
                  {value : 'index', text: '인덱스가 동일한 점들'},
                ]" v-b-tooltip.hover title="말풍선에 표시할 점의 종류를 지정합니다.">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.interaction">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="interactionIntersect" style="margin-bottom : 0rem">말풍선 표시</label>
                </b-input-group-text>
                <b-form-select required id="interactionIntersect" v-model="editingOptions.interaction.intersect" :options="[
                  {value : true, text: '교차시 표시'},
                  {value : false, text: '항상 표시함'},
                ]" v-b-tooltip.hover title="교차시 표시를 선택하면 마우수 커서를 올려야 말풍선을 표시합니다.">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipBackgroudColorConfig" style="margin-bottom : 0rem">말풍선 배경색</label>
                </b-input-group-text>
                <b-form-input :style="'background-color:' + editingOptions.plugins.tooltip.backgroundColor + ';'" v-touch:swipe.stop id="tooltipBackgroudColorConfig" v-model="editingOptions.plugins.tooltip.backgroundColor" type="text" required/>

                <b-button id="tooltipBackgroudColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="tooltipBackgroudColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="tooltipBackgroudColorObject" @input="applyColor('tooltipBackgroudColor')"></chrome-picker>
                </b-popover>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipBorderWidthConfig" style="margin-bottom : 0rem">말풍선 테두리 두께</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="tooltipBorderWidthConfig" :number="true" v-model="editingOptions.plugins.tooltip.borderWidth" min="0" max="20" type="number" required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipBorderColorConfig" style="margin-bottom : 0rem">말풍선 테두리색</label>
                </b-input-group-text>
                <b-form-input :style="'background-color:' + editingOptions.plugins.tooltip.borderColor + ';'" v-touch:swipe.stop id="tooltipBorderColorConfig" v-model="editingOptions.plugins.tooltip.borderColor" type="text" required/>

                <b-button id="tooltipBorderColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="tooltipBorderColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="tooltipBorderColorObject" @input="applyColor('tooltipBorderColor')"></chrome-picker>
                </b-popover>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipCaretSizeConfig" style="margin-bottom : 0rem">말풍선 꼭지 크기</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="tooltipCaretSizeConfig" :number="true" v-model="editingOptions.plugins.tooltip.caretSize" min="0" max="20" type="number" required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipPaddingConfig" style="margin-bottom : 0rem">말풍선 안쪽 여백</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="tooltipPaddingConfig" :number="true" v-model="editingOptions.plugins.tooltip.padding" min="0" max="20" type="number" required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipTitleColorConfig" style="margin-bottom : 0rem">말풍선 제목(시간) 색</label>
                </b-input-group-text>
                <b-form-input :style="'background-color:' + editingOptions.plugins.tooltip.titleColor + ';'" v-touch:swipe.stop id="tooltipTitleColorConfig" v-model="editingOptions.plugins.tooltip.titleColor" type="text" required/>

                <b-button id="tooltipTitleColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="tooltipTitleColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="tooltipTitleColorObject" @input="applyColor('tooltipTitleColor')"></chrome-picker>
                </b-popover>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip && editingOptions.plugins.tooltip.titleFont">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipTitleFontSizeConfig" style="margin-bottom : 0rem">말풍선 제목 글자 크기</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="tooltipTitleFontSizeConfig" :number="true" v-model="editingOptions.plugins.tooltip.titleFont.size" min="2" max="30" type="number" required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip && editingOptions.plugins.tooltip.titleFont">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipTitleFontWeightConfig" style="margin-bottom : 0rem">말풍선 제목 진하기</label>
                </b-input-group-text>
                <b-form-select required id="tooltipTitleFontWeightConfig" v-model="editingOptions.plugins.tooltip.titleFont.weight" :options="[
                  {value : 'bold', text: '진하게'},
                  {value : 'normal', text: '보통'},
                ]">
                </b-form-select>
              </b-input-group>


              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip && editingOptions.plugins.tooltip.bodyFont">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipBodyFontSizeConfig" style="margin-bottom : 0rem">말풍선 본문 글자 크기</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="tooltipBodyFontSizeConfig" :number="true" v-model="editingOptions.plugins.tooltip.bodyFont.size" min="2" max="30" type="number" required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip && editingOptions.plugins.tooltip.bodyFont">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipBodyFontWeightConfig" style="margin-bottom : 0rem">말풍선 본문 진하기</label>
                </b-input-group-text>
                <b-form-select required id="tooltipBodyFontWeightConfig" v-model="editingOptions.plugins.tooltip.bodyFont.weight" :options="[
                  {value : 'bold', text: '진하게'},
                  {value : 'normal', text: '보통'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.tooltip && editingOptions.plugins.tooltip">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="tooltipBodySpacingConfig" style="margin-bottom : 0rem">말풍선 본문 간격</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="tooltipBodySpacingConfig" :number="true" v-model="editingOptions.plugins.tooltip.bodySpacing" min="0" max="20" type="number" required/>
              </b-input-group>
            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'zoomConfig')">
                &dtrif; 확대/이동 설정
            </div>

            <b-collapse id="zoomConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.zoom && editingOptions.plugins.zoom.zoom && editingOptions.plugins.zoom.zoom.drag">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="zoomDragThresholdConfig" style="margin-bottom : 0rem">Drag로 확대 시작 최소값</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="zoomDragThresholdConfig" :number="true" v-model="editingOptions.plugins.zoom.zoom.drag.threshold" min="0" max="50" type="number" v-b-tooltip.hover title="그래프 확대가 되는 최소한의 드래그 거리" required/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.zoom && editingOptions.plugins.zoom.zoom && editingOptions.plugins.zoom.zoom.wheel">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="zoomWheelEnabledConfig" style="margin-bottom : 0rem">마우스 휠로 확대/축소</label>
                </b-input-group-text>
                <b-form-select required id="zoomWheelEnabledConfig" v-model="editingOptions.plugins.zoom.zoom.wheel.enabled" :options="[
                  {value : true, text: '사용'},
                  {value : false, text: '사용안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.zoom && editingOptions.plugins.zoom.zoom && editingOptions.plugins.zoom.zoom.wheel">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="zoomWheelSpeedConfig" style="margin-bottom : 0rem">휠로 확대/축소되는 속도</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="zoomWheelSpeedConfig" :number="true" v-model="editingOptions.plugins.zoom.zoom.wheel.speed" min="0.01" max="0.5" type="number"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions.plugins && editingOptions.plugins.zoom && editingOptions.plugins.zoom.zoom && editingOptions.plugins.zoom.zoom.pinch">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="zoomPinchEnabledConfig" style="margin-bottom : 0rem">두 손가락으로 확대/축소</label>
                </b-input-group-text>
                <b-form-select required id="zoomPinchEnabledConfig" v-model="editingOptions.plugins.zoom.zoom.pinch.enabled" :options="[
                  {value : true, text: '사용'},
                  {value : false, text: '사용안함'},
                ]">
                </b-form-select>
              </b-input-group>
            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'xAxisConfig')">
                &dtrif; X축(시간축) 설정
            </div>

            <b-collapse id="xAxisConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleDisplayConfig" style="margin-bottom : 0rem">X축 표시여부</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleDisplayConfig" v-model="editingOptions._tinkTimeScale.display" :options="[
                  {value : true, text: '표시'},
                  {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScalePositionConfig" style="margin-bottom : 0rem">X축 위치</label>
                </b-input-group-text>
                <b-form-select required id="timeScalePositionConfig" v-model="editingOptions._tinkTimeScale.position" :options="[
                  {value : 'top', text: '위'},
                  {value : 'bottom', text: '아래'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleReverseConfig" style="margin-bottom : 0rem">X축 뒤집기</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleReverseConfig" v-model="editingOptions._tinkTimeScale.reverse" :options="[
                  {value : true, text: '사용'},
                  {value : false, text: '사용안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleBorderWidthConfig" style="margin-bottom : 0rem">X축 두께</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="timeScaleBorderWidthConfig" :number="true" v-model="editingOptions._tinkTimeScale.grid.borderWidth" min="0" max="20" type="number"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleBackgroundColorConfig" style="margin-bottom : 0rem">X축 배경색</label>
                </b-input-group-text>

                <b-form-input :style="'background-color:' + editingOptions._tinkTimeScale.backgroundColor + ';'" v-touch:swipe.stop id="timeScaleBackgroundColorConfig" v-model="editingOptions._tinkTimeScale.backgroundColor" type="text" required/>

                <b-button id="timeScaleBackgroundColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="timeScaleBackgroundColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="timeScaleBackgroundColorObject" @input="applyColor('timeScaleBackgroundColor')"></chrome-picker>
                </b-popover>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleGridBorderColorConfig" style="margin-bottom : 0rem">X축 색상</label>
                </b-input-group-text>

                <b-form-input :style="'background-color:' + editingOptions._tinkTimeScale.grid.borderColor + ';'" v-touch:swipe.stop id="timeScaleGridBorderColorConfig" v-model="editingOptions._tinkTimeScale.grid.borderColor" type="text" required/>

                <b-button id="timeScaleGridBorderColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="timeScaleGridBorderColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="timeScaleGridBorderColorObject" @input="applyColor('timeScaleGridBorderColor')"></chrome-picker>
                </b-popover>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.title">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTitleDisplayConfig" style="margin-bottom : 0rem">X축 제목 표시여부</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleTitleDisplayConfig" v-model="editingOptions._tinkTimeScale.title.display" :options="[
                  {value : true, text: '표시'},
                  {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.title">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTitleTextConfig" style="margin-bottom : 0rem">X축 제목 내용</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="timeScaleTitleTextConfig" v-model="editingOptions._tinkTimeScale.title.text" type="text"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.title">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTitleColorConfig" style="margin-bottom : 0rem">X축 제목 색상</label>
                </b-input-group-text>

                <b-form-input :style="'background-color:' + editingOptions._tinkTimeScale.title.color + ';'" v-touch:swipe.stop id="timeScaleTitleColorConfig" v-model="editingOptions._tinkTimeScale.title.color" type="text" required/>

                <b-button id="timeScaleTitleColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="timeScaleTitleColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="timeScaleTitleColorObject" @input="applyColor('timeScaleTitleColor')"></chrome-picker>
                </b-popover>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale&&editingOptions._tinkTimeScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleGridColorConfig" style="margin-bottom : 0rem">X축 보조선과 눈금 색상</label>
                </b-input-group-text>

                <b-form-input :style="'background-color:' + editingOptions._tinkTimeScale.grid.color + ';'" v-touch:swipe.stop id="timeScaleGridColorConfig" v-model="editingOptions._tinkTimeScale.grid.color" type="text" required/>

                <b-button id="timeScaleGridColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="timeScaleGridColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="timeScaleGridColorObject" @input="applyColor('timeScaleGridColor')"></chrome-picker>
                </b-popover>
              </b-input-group>


              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleGridDrawOnChartAreaConfig" style="margin-bottom : 0rem">X축 보조선 표시</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleGridDrawOnChartAreaConfig" v-model="editingOptions._tinkTimeScale.grid.drawOnChartArea" :options="[
                  {value : true, text: '표시'},
                  {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleLineWidthConfig" style="margin-bottom : 0rem">X축 보조선 두께</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="timeScaleLineWidthConfig" :number="true" v-model="editingOptions._tinkTimeScale.grid.lineWidth" min="0" max="20" type="number"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleGridBorderDashConfig" style="margin-bottom : 0rem">X축 보조선 모양</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleGridBorderDashConfig" v-model="editingOptions._tinkTimeScale.grid.borderDash" :options="[
                {value : [], text: '실선 []'},
                {value : [2,2], text: '점선 [2,2]'},
                {value : [4,4], text: '점선 [4,4]'},
                {value : [8,8], text: '점선 [8,8]'},
                {value : [4,2], text: '빽빽 [4,2]'},
                {value : [8,2], text: '빡빡 [8,2]'},
                {value : [8,4], text: '촘촘 [8,4]'},
                {value : [2,4], text: '살핏 [2,4]'},
                {value : [2,8], text: '듬성 [2,8]'},
                {value : [4,8], text: '멀찍 [4,8]'},
                ]" v-b-tooltip.hover title="보조선의 파선 모양입니다. [2, 4]는 실선 2픽셀, 공백 2픽셀이 계속 된다는 뜻입니다.">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleGridDrawTicksConfig" style="margin-bottom : 0rem">X축 눈금 표시</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleGridDrawTicksConfig" v-model="editingOptions._tinkTimeScale.grid.drawTicks" :options="[
                  {value : true, text: '표시'},
                  {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.ticks">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTicksDisplayConfig" style="margin-bottom : 0rem">X축 라벨(시간) 표시</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleTicksDisplayConfig" v-model="editingOptions._tinkTimeScale.ticks.display" :options="[
                {value : true, text: '표시'},
                {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.ticks && editingOptions._tinkTimeScale.ticks.major">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTicksMajorConfig" style="margin-bottom : 0rem">큰단위 라벨도 표시</label>
                </b-input-group-text>
                <b-form-select required id="timeScaleTicksMajorConfig" v-model="editingOptions._tinkTimeScale.ticks.major.enabled" :options="[
                {value : true, text: '사용'},
                {value : false, text: '사용안함'},
                ]" v-b-tooltip.hover title="작은 단위의 눈금 라벨에 더해서 큰 단위 눈금도 가능한 경우에는 표시한다.">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.ticks">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTicksPaddingConfig" style="margin-bottom : 0rem">X축 라벨 여백</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="timeScaleTicksPaddingConfig" :number="true" v-model="editingOptions._tinkTimeScale.ticks.padding" min="0" max="20" type="number"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.ticks">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTicksMinRotationConfig" style="margin-bottom : 0rem">X축 라벨 회전 최소값</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="timeScaleTicksMinRotationConfig" :number="true" v-model="editingOptions._tinkTimeScale.ticks.minRotation" min="0" max="90" type="number" v-b-tooltip.hover title="회전 최대값과 최소값을 같은 값으로 지정하여 라벨이 회전하는 정도를 직접 지정할 수 있습니다. 0으로 지정하면 가로로, 90으로 지정하면 세로로 표시됩니다."/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkTimeScale && editingOptions._tinkTimeScale.ticks">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleTicksMaxRotationConfig" style="margin-bottom : 0rem">X축 라벨 회전 최대값</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="timeScaleTicksMaxRotationConfig" :number="true" v-model="editingOptions._tinkTimeScale.ticks.maxRotation" min="0" max="90" type="number"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="timeScaleShowValuePerConfig" style="margin-bottom : 0rem">X축 라벨 표시 간격</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="timeScaleShowValuePerConfig" :number="true" v-model="editingOptions._tinkTimeScaleTickShowValuePer" min="1" max="10" type="number" v-b-tooltip.hover title="몇 눈금마다 라벨을 표시할 지 여부. 1로 지정하면 모든 눈금에 라벨을 표시합니다."/>
              </b-input-group>

            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'yAxisConfig')">
                &dtrif; Y축(데이터축) 설정
            </div>

            <b-collapse id="yAxisConfig" accordion="folderAccordion" role="tabpanel" class="m-0 pt-dot1 pb-dot1 pl-3 pr-1">

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleGraceConfig" style="margin-bottom : 0rem">Y축 여유공간</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="valueScaleGraceConfig" :number="true" v-model="editingOptions._tinkValueScale.grace" min="0" max="1" type="number"  v-b-tooltip.hover title="Y축에 여유공간을 둡니다. 0.1은 위아래 합쳐서 10% 여유공간을 뜻합니다."/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleReverseConfig" style="margin-bottom : 0rem">Y축 뒤집기</label>
                </b-input-group-text>
                <b-form-select required id="valueScaleReverseConfig" v-model="editingOptions._tinkValueScale.reverse" :options="[
                  {value : true, text: '사용'},
                  {value : false, text: '사용안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleBorderWidthConfig" style="margin-bottom : 0rem">Y축 두께</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="valueScaleBorderWidthConfig" :number="true" v-model="editingOptions._tinkValueScale.grid.borderWidth" min="0" max="20" type="number"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleBackgroundColorConfig" style="margin-bottom : 0rem">Y축 배경색</label>
                </b-input-group-text>

                <b-form-input :style="'background-color:' + editingOptions._tinkValueScale.backgroundColor + ';'" v-touch:swipe.stop id="valueScaleBackgroundColorConfig" v-model="editingOptions._tinkValueScale.backgroundColor" type="text" required/>

                <b-button id="valueScaleBackgroundColorConfigButton" variant="primary" slot="append" class="pl-3 pr-3">
                  수정
                </b-button>
                <b-popover target="valueScaleBackgroundColorConfigButton" triggers="hover" placement="right" custom-class="colorPickerPopover">
                  <chrome-picker v-model="valueScaleBackgroundColorObject" @input="applyColor('valueScaleBackgroundColor')"></chrome-picker>
                </b-popover>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.title">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleTitleDisplayConfig" style="margin-bottom : 0rem">Y축 제목 표시 여부</label>
                </b-input-group-text>
                <b-form-select required id="valueScaleTitleDisplayConfig" v-model="editingOptions._tinkValueScale.title.display" :options="[
                  {value : true, text: '표시'},
                  {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleGridDrawOnChartAreaConfig" style="margin-bottom : 0rem">Y축 보조선 표시</label>
                </b-input-group-text>
                <b-form-select required id="valueScaleGridDrawOnChartAreaConfig" v-model="editingOptions._tinkValueScale.grid.drawOnChartArea" :options="[
                  {value : true, text: '표시'},
                  {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleLineWidthConfig" style="margin-bottom : 0rem">Y축 보조선 두께</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="valueScaleLineWidthConfig" :number="true" v-model="editingOptions._tinkValueScale.grid.lineWidth" min="0" max="20" type="number"/>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleGridBorderDashConfig" style="margin-bottom : 0rem">Y축 보조선 모양</label>
                </b-input-group-text>
                <b-form-select required id="valueScaleGridBorderDashConfig" v-model="editingOptions._tinkValueScale.grid.borderDash" :options="[
                {value : [], text: '실선 []'},
                {value : [2,2], text: '점선 [2,2]'},
                {value : [4,4], text: '점선 [4,4]'},
                {value : [8,8], text: '점선 [8,8]'},
                {value : [4,2], text: '빽빽 [4,2]'},
                {value : [8,2], text: '빡빡 [8,2]'},
                {value : [8,4], text: '촘촘 [8,4]'},
                {value : [2,4], text: '살핏 [2,4]'},
                {value : [2,8], text: '듬성 [2,8]'},
                {value : [4,8], text: '멀찍 [4,8]'},
                ]" v-b-tooltip.hover title="보조선의 파선 모양입니다. [2, 4]는 실선 2픽셀, 공백 2픽셀이 계속 된다는 뜻입니다.">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.grid">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleGridDrawTicksConfig" style="margin-bottom : 0rem">Y축 눈금 표시</label>
                </b-input-group-text>
                <b-form-select required id="valueScaleGridDrawTicksConfig" v-model="editingOptions._tinkValueScale.grid.drawTicks" :options="[
                  {value : true, text: '표시'},
                  {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.ticks">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleTicksDisplayConfig" style="margin-bottom : 0rem">Y축 라벨 표시</label>
                </b-input-group-text>
                <b-form-select required id="valueScaleTicksDisplayConfig" v-model="editingOptions._tinkValueScale.ticks.display" :options="[
                {value : true, text: '표시'},
                {value : false, text: '표시안함'},
                ]">
                </b-form-select>
              </b-input-group>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions._tinkValueScale && editingOptions._tinkValueScale.ticks">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="valueScaleTicksPaddingConfig" style="margin-bottom : 0rem">Y축 라벨 여백</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="valueScaleTicksPaddingConfig" :number="true" v-model="editingOptions._tinkValueScale.ticks.padding" min="0" max="20" type="number"/>
              </b-input-group>
            </b-collapse>
          </b-list-group-item>

          <b-list-group-item class="m-0 pt-dot1 pb-1 pl-2 pr-2">

            <div role="tab" variant="light" class="fontSizeDot9 ml-1 mr-1 mt-dot1 mb-dot1 p-0 font-weight-bold cursor-pointer" @click="$root.$emit('bv::toggle::collapse', 'colorConfig')">
                &dtrif; 색상 설정
            </div>

            <b-collapse id="colorConfig" accordion="folderAccordion" role="tabpanel" class="m-0 p-2">
              <b-table-simple hover small responsive class="fontSizeDot8" v-if="valuesFiltered && editingOptions && editingOptions._colorList">
                <colgroup><col style="width: 5rem;"></colgroup>
                <colgroup><col><col><col><col><col><col><col><col></colgroup>
                <b-thead head-variant="light">
                  <b-tr>
                    <b-th></b-th>
                    <b-th v-for="item in Array(8).keys()" :key="item" class="font-weight-normal text-center text-middle">
                      <span v-if="item < valuesFiltered.length">
                        {{valuesFiltered[item].title}}
                      </span>
                      <span v-else>
                        값{{item+1}}
                      </span>
                    </b-th>
                  </b-tr>
                </b-thead>
                <b-tbody>
                  <b-tr>
                    <b-th class="font-weight-normal align-middle">기본/평균값</b-th>
                    <b-td v-for="(color,index) in editingOptions._colorList" :key="index" class="p-0">
                      <b-form-input v-touch:swipe.stop v-model="editingOptions._colorList[index].average" type="color" class="border-0" style="height: 2rem;"/>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="font-weight-normal align-middle">중앙값</b-th>
                    <b-td v-for="(color,index) in editingOptions._colorList" :key="index" class="p-0">
                      <b-form-input v-touch:swipe.stop v-model="editingOptions._colorList[index].median" type="color" class="border-0" style="height: 2rem;"/>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="font-weight-normal align-middle">최대값</b-th>
                    <b-td v-for="(color,index) in editingOptions._colorList" :key="index" class="p-0">
                      <b-form-input v-touch:swipe.stop v-model="editingOptions._colorList[index].max" type="color" class="border-0" style="height: 2rem;"/>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="font-weight-normal align-middle">최소값</b-th>
                    <b-td v-for="(color,index) in editingOptions._colorList" :key="index" class="p-0">
                      <b-form-input v-touch:swipe.stop v-model="editingOptions._colorList[index].min" type="color" class="border-0" style="height: 2rem;"/>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="font-weight-normal align-middle">합계</b-th>
                    <b-td v-for="(color,index) in editingOptions._colorList" :key="index" class="p-0">
                      <b-form-input v-touch:swipe.stop v-model="editingOptions._colorList[index].sum" type="color" class="border-0" style="height: 2rem;"/>
                    </b-td>
                  </b-tr>
                  <b-tr>
                    <b-th class="font-weight-normal align-middle">횟수</b-th>
                    <b-td v-for="(color,index) in editingOptions._colorList" :key="index" class="p-0">
                      <b-form-input v-touch:swipe.stop v-model="editingOptions._colorList[index].count" type="color" class="border-0" style="height: 2rem;"/>
                    </b-td>
                  </b-tr>
                </b-tbody>
              </b-table-simple>

              <b-input-group size="sm" class="mt-1" v-if="editingOptions">
                <b-input-group-text slot="prepend" class="leftCellTitle">
                  <label for="paleColorPercentConfig" style="margin-bottom : 0rem">보조선 색 불투명도</label>
                </b-input-group-text>
                <b-form-input v-touch:swipe.stop id="paleColorPercentConfig" :number="true" v-model="editingOptions._tinkPaleColorOpacity" min="0" max="255" type="number" v-b-tooltip.hover title="보조선 색은 그래프 색에 불투명도가 적용됩니다. 255로 지정하면 보조선이 그래프 선 색과 동일하게 표시됩니다."/>
              </b-input-group>

            </b-collapse>
          </b-list-group-item>
        </b-list-group>


      </b-form>
      <template slot="modal-footer">
        <div>
          <b-button variant="outline-primary" size="sm" v-if="isLoginUserPageUser" @click="saveChartOptions('user')" class="mr-1">
            내 기본 설정으로 저장하기
          </b-button>
          <b-button variant="danger" size="sm" @click="hideModal('configGraphFloatModal')" class="mr-1">
            설정창 닫기
          </b-button>
        </div>
        <div style="flex-grow:2; text-align: right;">
          <b-button variant="secondary" size="sm" @click="applyChartOptions" class="mr-1">
            테스트 적용하기
          </b-button>
          <b-button variant="primary" size="sm" v-if="isLoginUserItemWritable(this.pageSensor)" @click="saveChartOptions('sensor')" class="mr-1">
            저장하고 적용하기
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal v-touch:swipe.stop size="lg" id="helpGraphFloatModal" tabindex="-1" title="그래프 도움말" static @show="modalShowFocus" header-bg-variant="primary" header-text-variant="light" footer-bg-variant="light" footer-text-variant="primary" header-class="pt-2 pb-2 pr-3 pl-3" footer-class="pt-1 pb-1 pr-3 pl-3" content-class="border-0" button-size="sm">

      <p class="fontSizeDot9 gothic" style="line-height: 170%;">
        현재 선택된 그룹, 범위, 열, 필터를 적용한 센서 데이터를 다운로드합니다. 아래 내용을 확인한 후에 다운로드 하시기 바랍니다.
        열 선택 여부와 상관없이 시간은 항상 포함되며, ID는  항상 포함되지 않습니다.
      </p>


      <template slot="modal-footer">
        <b-button variant="primary" size="sm">
          닫기
        </b-button>
      </template>
    </b-modal>

  </div>
</template>
<script>

import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { db } from "@/plugins/firebase.js";

import {
  Chart,
  LineController,
  LineElement,
  BarController,
  BarElement,
  PointElement,
  LinearScale,
  TimeScale,
  TimeSeriesScale,
  Title,
  Tooltip,
  CategoryScale
}
from "chart.js";

import zoomPlugin from "chartjs-plugin-zoom";
import "chartjs-adapter-luxon";

Chart.register(
  LineController,
  LineElement,
  BarController,
  BarElement,
  PointElement,
  LinearScale,
  TimeScale,
  TimeSeriesScale,
  Title,
  Tooltip,
  CategoryScale,
  zoomPlugin
);

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

import { Datetime } from "vue-datetime"
import { Settings } from "luxon"
import "vue-datetime/dist/vue-datetime.css"

import { mapActions } from "vuex"
import { mapState } from "vuex"
import { mapSetter } from "@/plugins/vuexUtils.js"

import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"

import sensorTabs from "@/components/sensor/sensorTabs.vue"

import eventBus from "@/plugins/eventBus.js";

import { Chrome } from "vue-color";

import { merge } from "lodash";

/*
import { merge, mergeWith } from "lodash";

function mergeWithArrayConcatCustomizer(obj, src) {
  if(Array.isArray(obj)) {
    return obj.concat(src);
  }
}

function mergeWithArrayReplaceCustomizer(obj, src) {
  if(Array.isArray(obj)) {
    return src;
  }
}

const mergeWithArrayConcat = function(obj, src) {
  return mergeWith(obj, src, mergeWithArrayConcatCustomizer);
};

const mergeWithArrayReplace = function(obj, src) {
  return mergeWith(obj, src, mergeWithArrayReplaceCustomizer);
};
*/

export default {
  name: "sensorGraph",
  mixins: [uiUtil, user],
  props: {
    pageUser: {
      type: Object,
      default: null
    },
    pageDevice: {
      type: Object,
      default: null
    },
    pageSensor: {
      type: Object,
      default: null
    },
    pageSensorHistory: {
      type: Object,
      default: null
    },
    pageBinded: {
      type: Boolean,
      default: false
    },
    graphKey: { type: Number, default: 0 },
    pFromId: { type: Number, default: null },
    pToId: { type: Number, default: null },
    pFromBook: { type: Number, default: null },
    pToBook: { type: Number, default: null },
    pFromDate: { type: String, default: "" },
    pToDate: { type: String, default: "" },
    pFromDateEpoch: { type: Number, default: null },
    pToDateEpoch: { type: Number, default: null },
    pXMin: { type: Number, default: null },
    pXMax: { type: Number, default: null },
    pPresentation: { type: Boolean, default: false },
    pScopeControl: { type: Boolean, default: true },
    pSubControl: { type: Boolean, default: true },
    pHeight: { type: String, default: "" },
    pOverflowY: { type: String, default: "" },
    pGroupBy: { type: String, default: "" },
    pColumns: { type: String, default: "" },
    pChartOptions: { type: String, default: "" },
  },
  components: {
    sensorTabs,
    'chrome-picker': Chrome,
    // tinkChart,
    VueSlider,
    Datetime,
  },

  data: function() {
    return {

      toastTimer : null,

      urlWithOptions: "",
      drawOnce: false,
      showScopeControl: true,
      showSubControl: true,

      backgroudColorObject: "",
      tooltipBackgroudColorObject: "",
      tooltipBorderColorObject: "",
      tooltipTitleColorObject: "",
      timeScaleGridColorObject: "",
      timeScaleGridBorderColorObject: "",
      timeScaleTitleColorObject: "",
      timeScaleBackgroundColorObject: "",
      valueScaleBackgroundColorObject: "",

      tinkPaleColorList: [],

      interactionEventsList: [ "mousemove", "mouseout", "click", "touchstart", "touchmove"],

      sensorData: [],

      groupByData: {
        "hour": [],
        "date": [],
        "month": []
      },
      groupByDataDirty: false,

      groupBy: "default",
      performanceMode: false,

      groupByOptions: [
        { value: "default", text: "없음" },
        { value: "hour", text: "시" },
        { value: "date", text: "일" },
        { value: "month", text: "월" }
      ],

      typeOptions: [
        { value: "average", text: "평균" },
        { value: "median", text: "중앙" },
        { value: "max", text: "최대" },
        { value: "min", text: "최소" },
        { value: "sum", text: "합계" },
        { value: "count", text: "횟수" },
      ],

      valueTypeList: {
        "average": {
          "short": "a",
          "text": "평균",
          "index": 0,
        },
        "median": {
          "short": "m",
          "text": "중간",
          "index": 1,
        },
        "max": {
          "short": "x",
          "text": "최대",
          "index": 2,
        },
        "min": {
          "short": "n",
          "text": "최소",
          "index": 3,
        },
        "sum": {
          "short": "s",
          "text": "합계",
          "index": 4,
        },
        "count": {
          "short": "c",
          "text": "횟수",
          "index": 5,
        },
      },

      columns: {
        "default": [],
        "hour": {},
        "date": {},
        "month": {},
      },

      columnsOptions: {
        "default": {},
        "hour": {},
        "date": {},
        "month": {},
      },

      tinkChartElement: null,
      tinkChart: null,

      defaultDataset: {
        fill: false,
        hidden: true,
        data: [],
      },

      performanceOptions: {
        parsing: false,
        animation: {
          duration: 0
        },
        elements: {
          point: {
            radius: 0,
            hoverRadius: 0,
          },
          line: {
            borderWidth: 1,
            tension: 0,
            stepped: false,
          }
        },
        interaction: {
          mode: "index"
        },
        events: ["click"],
        plugins: {
          tooltip: {
            enabled: false,
          },
          zoom: {
            zoom: {
              wheel: {
                enabled: false,
              },
              pinch: {
                enabled: false,
              },
            }
          },
        },
      },

      defaultEditingOptions: {
        aspectRatio: 2.35,
        layout: {
          padding: 0,
        },
        animation: {
          duration: 1000,
          easing: "linear",
        },
        elements: {
          point: {
            radius: 1,
            hoverRadius: 4,
            pointStyle: "circle",
          },
          line: {
            borderWidth: 1,
            tension: 0.1,
            stepped: false,
          }
        },
        interaction: {
          mode: "index",
          intersect: true,
        },
        events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],
        plugins: {
          tooltip: {
            enabled: true,
            padding: 6,
            backgroundColor: "#FFFFFFA0",

            borderColor: "rgba(0,0,0,0.6)",
            borderWidth: 1,

            titleColor: "rgba(0,0,0,1)",
            titleAlign: "center",
            titleFont: {
              weight: "bold",
              size: 12,
            },
            titleMarginBottom: 2,

            bodyAlign: "right",
            bodyFont: {
              weight: "bold",
              size: 11,
            },
            bodySpacing: 2,

            caretSize: 8,
            cornerRadius: 4,
          },
          zoom: {
            pan: {
              enabled: false,
              mode: "x",
              threshold: 10,
            },
            zoom: {
              drag: {
                enabled: true,
                threshold: 10,
              },
              wheel: {
                enabled: true,
                speed: 0.2,
              },
              pinch: {
                enabled: true
              },
              mode: "x",
            },
          }
        },
        _tinkGroupByAutoApplyLength: 100000,
        _tinkPerformanceAutoApplyLength: 50000,
        _tinkChartType: "line",
        _tinkPaleColorOpacity: 64,
        _tinkTimeScaleTickShowValuePer: 2,
        _tinkBackgroundColor: "#FFFFFF00",
        _tinkCanvasMargin: 2,
        _tinkPresentationHeightResizePercent: 40,

        _colorList: [
          {
            "average" : "#008080", // Teal
            "median" : "#556B2F", // DarkOliveGreen
            "max" : "#006400", // DarkGreen
            "min" : "#2E8B57", // SeaGreen
            "sum" : "#808000", // Olive
            "count" : "#32CD32", // LimeGreen
          },
          {
            "average" : "#4169E1", // RoyalBlue
            "median" : "#191970", // MidnightBlue
            "max" : "#1E90FF", // DodgerBlue
            "min" : "#4682B4", // SteelBlue
            "sum" : "#87CEEB", // SkyBlue
            "count" : "#40E0D0", // Turquoise
          },
          {
            "average" : "#DC143C", // Crimson
            "median" : "#B22222", // FireBrick
            "max" : "#FF0000", // Red
            "min" : "#CD5C5C", // IndianRed
            "sum" : "#8B0000", // DarkRed
            "count" : "#F08080", // LightCoral
          },
          {
            "average" : "#9400D3", // DarkViolet
            "median" : "#DA70D6", // Orchid
            "max" : "#800080", // Purple
            "min" : "#4B0082", // Indigo
            "sum" : "#FF00FF", // Magenta
            "count" : "#663399", // RebeccaPurple
          },
          {
            "average" : "#A52A2A", // Brown
            "median" : "#D2691E", // Chocolate
            "max" : "#CD853F", // Peru
            "min" : "#DAA520", // Goldenrod
            "sum" : "#F4A460", // SandyBrown
            "count" : "#D2B48C", // Tan
          },
          {
            "average" : "#FF6347", // Tomato
            "median" : "#FFA500", // Orange
            "max" : "#FF8C00", // DarkOrange
            "min" : "#FF4500", // OrangeRed
            "sum" : "#FF7F50", // Coral
            "count" : "#FFA07A", // LightSalmon
          },
          {
            "average" : "#C71585", // MediumVioletRed
            "median" : "#DB7093", // PaleVioletRed
            "max" : "#FF1493", // DeepPink
            "min" : "#FF69B4", // HotPink
            "sum" : "#FFC0CB", // Pink
            "count" : "#FFB6C1", // LightPink
          },
          {
            "average" : "#BDB76B", // DarkKhaki
            "median" : "#F0E68C", // Khaki
            "max" : "#FFD700", // Gold
            "min" : "#FFFF00", // Yellow
            "sum" : "#EEE8AA", // PaleGoldenrod
            "count" : "#FFDAB9", // PeachPuff
          },
          {
            "average" : "#008080", // Teal
            "median" : "#556B2F", // DarkOliveGreen
            "max" : "#006400", // DarkGreen
            "min" : "#2E8B57", // SeaGreen
            "sum" : "#808000", // Olive
            "count" : "#32CD32", // LimeGreen
          },
          {
            "average" : "#4169E1", // RoyalBlue
            "median" : "#191970", // MidnightBlue
            "max" : "#1E90FF", // DodgerBlue
            "min" : "#4682B4", // SteelBlue
            "sum" : "#87CEEB", // SkyBlue
            "count" : "#40E0D0", // Turquoise
          },
          {
            "average" : "#DC143C", // Crimson
            "median" : "#B22222", // FireBrick
            "max" : "#FF0000", // Red
            "min" : "#CD5C5C", // IndianRed
            "sum" : "#8B0000", // DarkRed
            "count" : "#F08080", // LightCoral
          },
          {
            "average" : "#9400D3", // DarkViolet
            "median" : "#DA70D6", // Orchid
            "max" : "#800080", // Purple
            "min" : "#4B0082", // Indigo
            "sum" : "#FF00FF", // Magenta
            "count" : "#663399", // RebeccaPurple
          },
          {
            "average" : "#A52A2A", // Brown
            "median" : "#D2691E", // Chocolate
            "max" : "#CD853F", // Peru
            "min" : "#DAA520", // Goldenrod
            "sum" : "#F4A460", // SandyBrown
            "count" : "#D2B48C", // Tan
          },
          {
            "average" : "#FF6347", // Tomato
            "median" : "#FFA500", // Orange
            "max" : "#FF8C00", // DarkOrange
            "min" : "#FF4500", // OrangeRed
            "sum" : "#FF7F50", // Coral
            "count" : "#FFA07A", // LightSalmon
          },
          {
            "average" : "#C71585", // MediumVioletRed
            "median" : "#DB7093", // PaleVioletRed
            "max" : "#FF1493", // DeepPink
            "min" : "#FF69B4", // HotPink
            "sum" : "#FFC0CB", // Pink
            "count" : "#FFB6C1", // LightPink
          },
          {
            "average" : "#BDB76B", // DarkKhaki
            "median" : "#F0E68C", // Khaki
            "max" : "#FFD700", // Gold
            "min" : "#FFFF00", // Yellow
            "sum" : "#EEE8AA", // PaleGoldenrod
            "count" : "#FFDAB9", // PeachPuff
          }
        ],

        _tinkTimeScale: {
          type: "time",
          display: true,
          backgroundColor: "#FFFFFF00",
          title: {
            display: true,
            text: "측정시간",
            color: "#000090",
          },
          position: "bottom",
          reverse: false,
          grid: {
            drawOnChartArea: true,
            drawTicks: true,
            color: "rgba(0,0,0,0.1)",
            borderColor: "rgba(0,0,0,1)",
            display: true,
            borderWidth: 2,
            borderDash: [2, 4],
            lineWidth: 1,
          },
          ticks: {
            display: true,
            align: "center",
            minRotation: 0,
            maxRotation: 45,
            padding: 3,
            major: {
              enabled: true,
            },
          },
        },

        _tinkValueScale: {
          // id,
          type: 'linear',
          position: "left",
          backgroundColor: "#FFFFFF00",
          display: false,
          title: {
            display: false,
            // text
            // color
          },
          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: true,
            // color
            // borderColor
            borderWidth: 2,
            borderDash: [2, 4],
            lineWidth: 1,
          },
          ticks: {
            display: true,
            // color
            padding: 3,
          },
          grace: 0.1,
          beginAtZero: false,
          reverse: false,
        },

      },

      editingOptions: {
        aspectRatio: 2.35,
        layout: {
          padding: 0,
        },
        animation: {
          duration: 1000,
          easing: "linear",
        },
        elements: {
          point: {
            radius: 1,
            hoverRadius: 4,
            pointStyle: "circle",
          },
          line: {
            borderWidth: 1,
            tension: 0.1,
            stepped: false,
          }
        },
        interaction: {
          mode: "index",
          intersect: true,
        },
        events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],
        plugins: {
          tooltip: {
            enabled: true,
            padding: 6,
            backgroundColor: "#FFFFFFA0",

            borderColor: "rgba(0,0,0,0.6)",
            borderWidth: 1,

            titleColor: "rgba(0,0,0,1)",
            titleAlign: "center",
            titleFont: {
              weight: "bold",
              size: 12,
            },
            titleMarginBottom: 2,

            bodyAlign: "right",
            bodyFont: {
              weight: "bold",
              size: 11,
            },
            bodySpacing: 2,

            caretSize: 8,
            cornerRadius: 4,
          },
          zoom: {
            pan: {
              enabled: false,
              mode: "x",
              threshold: 10,
            },
            zoom: {
              drag: {
                enabled: true,
                threshold: 10,
              },
              wheel: {
                enabled: true,
                speed: 0.2,
              },
              pinch: {
                enabled: true
              },
              mode: "x",
            },
          }
        },
        _tinkGroupByAutoApplyLength: 100000,
        _tinkPerformanceAutoApplyLength: 50000,
        _tinkChartType: "line",
        _tinkPaleColorOpacity: 64,
        _tinkTimeScaleTickShowValuePer: 2,
        _tinkBackgroundColor: "#FFFFFF00",
        _tinkCanvasMargin: 2,
        _tinkPresentationHeightResizePercent: 40,

        _colorList: [
          {
            "average" : "#008080", // Teal
            "median" : "#556B2F", // DarkOliveGreen
            "max" : "#006400", // DarkGreen
            "min" : "#2E8B57", // SeaGreen
            "sum" : "#808000", // Olive
            "count" : "#32CD32", // LimeGreen
          },
          {
            "average" : "#4169E1", // RoyalBlue
            "median" : "#191970", // MidnightBlue
            "max" : "#1E90FF", // DodgerBlue
            "min" : "#4682B4", // SteelBlue
            "sum" : "#87CEEB", // SkyBlue
            "count" : "#40E0D0", // Turquoise
          },
          {
            "average" : "#DC143C", // Crimson
            "median" : "#B22222", // FireBrick
            "max" : "#FF0000", // Red
            "min" : "#CD5C5C", // IndianRed
            "sum" : "#8B0000", // DarkRed
            "count" : "#F08080", // LightCoral
          },
          {
            "average" : "#9400D3", // DarkViolet
            "median" : "#DA70D6", // Orchid
            "max" : "#800080", // Purple
            "min" : "#4B0082", // Indigo
            "sum" : "#FF00FF", // Magenta
            "count" : "#663399", // RebeccaPurple
          },
          {
            "average" : "#A52A2A", // Brown
            "median" : "#D2691E", // Chocolate
            "max" : "#CD853F", // Peru
            "min" : "#DAA520", // Goldenrod
            "sum" : "#F4A460", // SandyBrown
            "count" : "#D2B48C", // Tan
          },
          {
            "average" : "#FF6347", // Tomato
            "median" : "#FFA500", // Orange
            "max" : "#FF8C00", // DarkOrange
            "min" : "#FF4500", // OrangeRed
            "sum" : "#FF7F50", // Coral
            "count" : "#FFA07A", // LightSalmon
          },
          {
            "average" : "#C71585", // MediumVioletRed
            "median" : "#DB7093", // PaleVioletRed
            "max" : "#FF1493", // DeepPink
            "min" : "#FF69B4", // HotPink
            "sum" : "#FFC0CB", // Pink
            "count" : "#FFB6C1", // LightPink
          },
          {
            "average" : "#BDB76B", // DarkKhaki
            "median" : "#F0E68C", // Khaki
            "max" : "#FFD700", // Gold
            "min" : "#FFFF00", // Yellow
            "sum" : "#EEE8AA", // PaleGoldenrod
            "count" : "#FFDAB9", // PeachPuff
          },
          {
            "average" : "#008080", // Teal
            "median" : "#556B2F", // DarkOliveGreen
            "max" : "#006400", // DarkGreen
            "min" : "#2E8B57", // SeaGreen
            "sum" : "#808000", // Olive
            "count" : "#32CD32", // LimeGreen
          },
          {
            "average" : "#4169E1", // RoyalBlue
            "median" : "#191970", // MidnightBlue
            "max" : "#1E90FF", // DodgerBlue
            "min" : "#4682B4", // SteelBlue
            "sum" : "#87CEEB", // SkyBlue
            "count" : "#40E0D0", // Turquoise
          },
          {
            "average" : "#DC143C", // Crimson
            "median" : "#B22222", // FireBrick
            "max" : "#FF0000", // Red
            "min" : "#CD5C5C", // IndianRed
            "sum" : "#8B0000", // DarkRed
            "count" : "#F08080", // LightCoral
          },
          {
            "average" : "#9400D3", // DarkViolet
            "median" : "#DA70D6", // Orchid
            "max" : "#800080", // Purple
            "min" : "#4B0082", // Indigo
            "sum" : "#FF00FF", // Magenta
            "count" : "#663399", // RebeccaPurple
          },
          {
            "average" : "#A52A2A", // Brown
            "median" : "#D2691E", // Chocolate
            "max" : "#CD853F", // Peru
            "min" : "#DAA520", // Goldenrod
            "sum" : "#F4A460", // SandyBrown
            "count" : "#D2B48C", // Tan
          },
          {
            "average" : "#FF6347", // Tomato
            "median" : "#FFA500", // Orange
            "max" : "#FF8C00", // DarkOrange
            "min" : "#FF4500", // OrangeRed
            "sum" : "#FF7F50", // Coral
            "count" : "#FFA07A", // LightSalmon
          },
          {
            "average" : "#C71585", // MediumVioletRed
            "median" : "#DB7093", // PaleVioletRed
            "max" : "#FF1493", // DeepPink
            "min" : "#FF69B4", // HotPink
            "sum" : "#FFC0CB", // Pink
            "count" : "#FFB6C1", // LightPink
          },
          {
            "average" : "#BDB76B", // DarkKhaki
            "median" : "#F0E68C", // Khaki
            "max" : "#FFD700", // Gold
            "min" : "#FFFF00", // Yellow
            "sum" : "#EEE8AA", // PaleGoldenrod
            "count" : "#FFDAB9", // PeachPuff
          },
        ],

        _tinkTimeScale: {
          type: "time", // "timeseries", "time"
          display: true,
          backgroundColor: "#FFFFFF00",
          title: {
            display: true,
            text: "측정시간",
            color: "#000090",
          },
          position: "bottom",
          reverse: false,
          grid: {
            drawOnChartArea: true,
            drawTicks: true,
            color: "rgba(0,0,0,0.1)",
            borderColor: "rgba(0,0,0,1)",
            display: true,
            borderWidth: 2,
            borderDash: [2, 4],
            lineWidth: 1,
          },
          ticks: {
            display: true,
            align: "center",
            minRotation: 0,
            maxRotation: 45,
            padding: 3,
            major: {
              enabled: true,
            },
          },
        },

        _tinkValueScale: {
          // id,
          type: 'linear',
          position: "left",
          backgroundColor: "#FFFFFF00",
          display: false,
          title: {
            display: false,
            // text
            // color
          },
          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: true,
            // color
            // borderColor
            borderWidth: 2,
            borderDash: [2, 4],
            lineWidth: 1,
          },
          ticks: {
            display: true,
            // color
            padding: 3,
          },
          grace: 0.1,
          beginAtZero: false,
          reverse: false,
        },

      },

      tinkOptions: {
        maintainAspectRatio: true,
        aspectRatio: 2.35,
        parsing: false,
        layout: {
          padding: 0,
        },
        animation: {
          duration: 1000,
          easing: "linear",
        },
        elements: {
          point: {
            radius: 1,
            hoverRadius: 4,
            pointStyle: "circle",
          },
          line: {
            borderWidth: 1,
            tension: 0.1,
            stepped: false,
          }
        },
        interaction: {
          mode: "index",
          intersect: true,
        },
        events: ["mousemove", "mouseout", "click", "touchstart", "touchmove"],
        onClick: evt => {
          if(this.tinkOptions._tinkZoomEnabled) {
            if(evt.native.altKey || evt.native.ctrlKey || evt.native.shiftKey) {
              this.zoomOut();
            }
            else {
              if(evt.x > this.tinkChart.width*0.4 && evt.x < this.tinkChart.width*0.6) {
                this.zoomIn();
              }
              else if(evt.x < this.tinkChart.width*0.2 || evt.x > this.tinkChart.width*0.8) {
                this.zoomOut();
              }
            }
          }
          else {
            if(evt.x < this.tinkChart.width*0.2) {
              this.panLeft();
            }
            else if(evt.x > this.tinkChart.width*0.8) {
              this.panRight();
            }
          }
        },
        plugins: {
          tooltip: {
            enabled: true,
            padding: 6,
            backgroundColor: "#FFFFFFA0",

            borderColor: "rgba(0,0,0,0.6)",
            borderWidth: 1,

            titleColor: "rgba(0,0,0,1)",
            titleAlign: "center",
            titleFont: {
              weight: "bold",
              size: 12,
            },
            titleMarginBottom: 2,

            bodyAlign: "right",
            bodyFont: {
              weight: "bold",
              size: 11,
            },
            bodySpacing: 2,

            caretSize: 8,
            cornerRadius: 4,

            callbacks: {
              title: (context) => {
                if(this.groupBy == "default") {
                  return this.dateToString(new Date(context[0].raw.x));
                }
                else if(this.groupBy == "hour") {
                  return this.dateToTillHourString(new Date(context[0].raw.x)) + "시";
                }
                else if(this.groupBy == "date") {
                  return this.dateToDateOnlyString(new Date(context[0].raw.x));
                }
                else if(this.groupBy == "year") {
                  return this.dateToTillMonthString(new Date(context[0].raw.x)) + "월";
                }
              },
              label: context => {
                let label = context.dataset.label || " ";
                if(label) {
                  label += ": ";
                }
                if(context.parsed.y !== null) {
                  if(typeof(this.valuesFiltered[context.dataset._index].unit) == "undefined") {
                    label += context.parsed.y;
                  }
                  else {
                    label += context.parsed.y + " " + this.valuesFiltered[context.dataset._index].unit;
                  }

                }
                return label;
              },
              labelTextColor: context => {
                return this.tinkOptions._colorList[context.dataset._index].average;
              },
            },
          },
          zoom: {
            pan: {
              enabled: false,
              mode: "x",
              threshold: 10,
              onPanComplete:()=> {
                this.onPanComplete();
              },
            },
            zoom: {
              drag: {
                enabled: true,
                threshold: 10,
              },
              wheel: {
                enabled: true,
                speed: 0.2,
              },
              pinch: {
                enabled: true
              },
              mode: "x",
              onZoomComplete: ()=> {
                this.onZoomComplete();
              },
            },
            limits: {}
          }
        },
        _tinkGroupByAutoApplyLength: 100000,
        _tinkPerformanceAutoApplyLength: 50000,
        _tinkChartType: "line",
        _tinkPaleColorOpacity: 64,
        _tinkTimeScaleTickShowValuePer: 2,
        _tinkBackgroundColor: "#FFFFFF00",
        _tinkCanvasMargin: 2,
        _tinkPresentationHeightResizePercent: 40,

        _colorList: [
          {
            "average" : "#008080", // Teal
            "median" : "#556B2F", // DarkOliveGreen
            "max" : "#006400", // DarkGreen
            "min" : "#2E8B57", // SeaGreen
            "sum" : "#808000", // Olive
            "count" : "#32CD32", // LimeGreen
          },
          {
            "average" : "#4169E1", // RoyalBlue
            "median" : "#191970", // MidnightBlue
            "max" : "#1E90FF", // DodgerBlue
            "min" : "#4682B4", // SteelBlue
            "sum" : "#87CEEB", // SkyBlue
            "count" : "#40E0D0", // Turquoise
          },
          {
            "average" : "#DC143C", // Crimson
            "median" : "#B22222", // FireBrick
            "max" : "#FF0000", // Red
            "min" : "#CD5C5C", // IndianRed
            "sum" : "#8B0000", // DarkRed
            "count" : "#F08080", // LightCoral
          },
          {
            "average" : "#9400D3", // DarkViolet
            "median" : "#DA70D6", // Orchid
            "max" : "#800080", // Purple
            "min" : "#4B0082", // Indigo
            "sum" : "#FF00FF", // Magenta
            "count" : "#663399", // RebeccaPurple
          },
          {
            "average" : "#A52A2A", // Brown
            "median" : "#D2691E", // Chocolate
            "max" : "#CD853F", // Peru
            "min" : "#DAA520", // Goldenrod
            "sum" : "#F4A460", // SandyBrown
            "count" : "#D2B48C", // Tan
          },
          {
            "average" : "#FF6347", // Tomato
            "median" : "#FFA500", // Orange
            "max" : "#FF8C00", // DarkOrange
            "min" : "#FF4500", // OrangeRed
            "sum" : "#FF7F50", // Coral
            "count" : "#FFA07A", // LightSalmon
          },
          {
            "average" : "#C71585", // MediumVioletRed
            "median" : "#DB7093", // PaleVioletRed
            "max" : "#FF1493", // DeepPink
            "min" : "#FF69B4", // HotPink
            "sum" : "#FFC0CB", // Pink
            "count" : "#FFB6C1", // LightPink
          },
          {
            "average" : "#BDB76B", // DarkKhaki
            "median" : "#F0E68C", // Khaki
            "max" : "#FFD700", // Gold
            "min" : "#FFFF00", // Yellow
            "sum" : "#EEE8AA", // PaleGoldenrod
            "count" : "#FFDAB9", // PeachPuff
          },
          {
            "average" : "#008080", // Teal
            "median" : "#556B2F", // DarkOliveGreen
            "max" : "#006400", // DarkGreen
            "min" : "#2E8B57", // SeaGreen
            "sum" : "#808000", // Olive
            "count" : "#32CD32", // LimeGreen
          },
          {
            "average" : "#4169E1", // RoyalBlue
            "median" : "#191970", // MidnightBlue
            "max" : "#1E90FF", // DodgerBlue
            "min" : "#4682B4", // SteelBlue
            "sum" : "#87CEEB", // SkyBlue
            "count" : "#40E0D0", // Turquoise
          },
          {
            "average" : "#DC143C", // Crimson
            "median" : "#B22222", // FireBrick
            "max" : "#FF0000", // Red
            "min" : "#CD5C5C", // IndianRed
            "sum" : "#8B0000", // DarkRed
            "count" : "#F08080", // LightCoral
          },
          {
            "average" : "#9400D3", // DarkViolet
            "median" : "#DA70D6", // Orchid
            "max" : "#800080", // Purple
            "min" : "#4B0082", // Indigo
            "sum" : "#FF00FF", // Magenta
            "count" : "#663399", // RebeccaPurple
          },
          {
            "average" : "#A52A2A", // Brown
            "median" : "#D2691E", // Chocolate
            "max" : "#CD853F", // Peru
            "min" : "#DAA520", // Goldenrod
            "sum" : "#F4A460", // SandyBrown
            "count" : "#D2B48C", // Tan
          },
          {
            "average" : "#FF6347", // Tomato
            "median" : "#FFA500", // Orange
            "max" : "#FF8C00", // DarkOrange
            "min" : "#FF4500", // OrangeRed
            "sum" : "#FF7F50", // Coral
            "count" : "#FFA07A", // LightSalmon
          },
          {
            "average" : "#C71585", // MediumVioletRed
            "median" : "#DB7093", // PaleVioletRed
            "max" : "#FF1493", // DeepPink
            "min" : "#FF69B4", // HotPink
            "sum" : "#FFC0CB", // Pink
            "count" : "#FFB6C1", // LightPink
          },
          {
            "average" : "#BDB76B", // DarkKhaki
            "median" : "#F0E68C", // Khaki
            "max" : "#FFD700", // Gold
            "min" : "#FFFF00", // Yellow
            "sum" : "#EEE8AA", // PaleGoldenrod
            "count" : "#FFDAB9", // PeachPuff
          },
        ],

        _tinkTimeScale: {
          type: "time",
          display: true,
          backgroundColor: "#FFFFFF00",
          title: {
            display: true,
            text: "측정시간",
            color: "#000090",
          },
          position: "bottom",
          reverse: false,
          grid: {
            drawOnChartArea: true,
            drawTicks: true,
            color: "rgba(0,0,0,0.1)",
            borderColor: "rgba(0,0,0,1)",
            display: true,
            borderWidth: 2,
            borderDash: [2, 4],
            lineWidth: 1,
          },
          ticks: {
            display: true,
            align: "center",
            minRotation: 0,
            maxRotation: 45,
            padding: 3,
            major: {
              enabled: true,
            },
            callback: (value, index, values) => {
              return Math.ceil(index) % this.tinkOptions._tinkTimeScaleTickShowValuePer == 0 ? value : "";
            },
          },
        },

        _tinkValueScale: {
          // id,
          type: 'linear',
          backgroundColor: "#FFFFFF00",
          position: "left",
          display: false,
          title: {
            display: false,
            // text
            // color
          },
          grid: {
            display: true,
            drawOnChartArea: true,
            drawTicks: true,
            // color
            // borderColor
            borderWidth: 2,
            borderDash: [2, 4],
            lineWidth: 1,
          },
          ticks: {
            display: true,
            // color
            padding: 3,
          },
          grace: 0.1,
          beginAtZero: false,
          reverse: false,
        },

        _tinkZoomEnabled: true,
        _tinkScaleXMin: null,
        _tinkScaleXMax: null,
        _tinkScaleXOriginalMin: null,
        _tinkScaleXOriginalMax: null,
        _tinkDataReady: false,
      },

      tinkChartData: {
        "default": [],
        "hour": [],
        "date": [],
        "month": []
      },

      showUpdateButton: false,
      lastBook: 0,
      lastIndex: -1,
      bookInfo: null,
      lastValues: null,
      oldBook: null,
      oldIndex: null,

      valuesFiltered: null,
      valuesFilteredIndex: {},
      valuesFilteredList: {},

      scopeFromDate: null,
      scopeFromId: null,
      oldScopeFromId: null,
      scopeFromDateSelected: false,

      scopeToDate: null,
      scopeToId: null,
      oldScopeToId: null,
      scopeToDateSelected: false,

      scopeSliderShow: false,
      scopeSliderTultips: "always",

      sliderValues: [],
      sliderStep: [],
      sliderShow: false,


    }
  },

  created: function() {
    Settings.defaultLocale = this.getLang();
  },

  mounted: function() {
    this.init();
    window.setTimeout(()=> {
      if(this.el("scopeFromDate")) this.el("scopeFromDate").tabIndex = "-1";
      if(this.el("scopeToDate")) this.el("scopeToDate").tabIndex = "-1";
    }, 200);
    this.initChart();
    this.setChartMessagePosition();
    this.getData(true);
  },

  beforeDestroy: function() {
    if(this.groupByDataDirty) {
      this.$set(this.$parent.$parent, "pageSensorHistory", {});
    }
  },

  updated: function() {

    if(this.groupBy == "default") {

      if(this.pageDevice.active) {

        // 데이터수는 같은 데 데이터가 달라졌다.
        if(this.rowCount == this.sensorRowCount) {
          if(this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime()) {

            if(this.toastTimer != null) {
              window.clearTimeout(this.toastTimer);
            }

            this.toastTimer = window.setTimeout(()=> {
              this.$parent.$parent.makeToast("info", "데이터 동기화", "데이터 수는 같은 데 최종 수정일이 달라졌습니다. 화면을 초기화했습니다.", {
                "autoHideDelay": 5000
              });
            }, 100);

            this.$parent.$parent.pageSensorHistory = {};
            this.$parent.$parent.resetGraph();
          }
        }

        // 데이터가 줄어들었다.
        else if((this.sensorRowCount - this.rowCount) < 0) {

          if(this.toastTimer != null) {
            window.clearTimeout(this.toastTimer);
          }
          this.toastTimer = window.setTimeout(()=> {
            this.$parent.$parent.makeToast("info", "데이터 동기화", "서버에 저장된 데이터 수가 현재 데이터 수보다 적습니다. 화면을 초기화했습니다.",{
              "autoHideDelay": 5000
            });
          }, 100);
          this.$set(this.$parent.$parent, "pageSensorHistory", {});
          this.$parent.$parent.resetGraph();
        }

        // 1줄 늘어났다.
        else if((this.sensorRowCount - this.rowCount) == 1) {

          this.showUpdateButton = true;

          // added
          if(this.scopeToId == (this.rowCount-1)) {
            this.scopeToId = this.sensorRowCount - 1;
            if(this.sliderValues.length == 2) {
              this.$set(this.sliderValues, 1, this.scopeToIdEnd);
            }
            else if(this.sliderValues.length == 0) {
              this.sliderValues.push(this.scopeFromId-1);
              this.sliderValues.push(this.scopeToIdEnd);
            }
          }

          if(this.pageSensor.lastIndex == 0) {
            this.$set(this.$parent.$parent.pageSensorHistory, this.pageSensor.lastBook+ "", {
              dirty: false,
              data: {}
            });
            if(this.sliderStep.length != 0) {
              this.sliderStep.push(this.sensorRowCount-1);
            }
          }
          else {
            if(this.sliderStep.length != 0) {
              this.sliderStep.pop();
              this.sliderStep.push(this.sensorRowCount-1);
            }
          }

          if(this.pageSensor.lastIndex == 0) {
            this.pageSensorHistory[this.pageSensor.lastBook+ ""] = {
              dirty: false,
              data: {}
            }
          }

          if(typeof(this.$parent.$parent.pageSensorHistory[this.pageSensor.lastBook + ""]) != "undefined") {
            this.$set(this.$parent.$parent.pageSensorHistory[this.pageSensor.lastBook + ""].data, this.pageSensor.lastIndex+ "", this.pageSensor.lastValues);
          }

          /*
          let toAdd = {
            id: this.sensorRowCount-1,
            selected: false,
            deleted: false,
            edited: false,
            data: this.pageSensor.lastValues
          }
          */

          this.lastBook = this.pageSensor.lastBook
          this.lastIndex = this.pageSensor.lastIndex
          this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate()
          this.lastValues = this.pageSensor.lastValues
          this.bookInfo = this.pageSensor.bookInfo

          if(this.sensorData.length > 0) {

            /*
            if(((this.sensorRowCount-1) >= this.sensorData[0].id) && ((this.sensorRowCount-2) <= this.sensorData[this.sensorData.length-1].id)) {
              this.sensorData.push(toAdd);
            }
            */

            if((this.sensorRowCount-1) >= this.oldScopeFromId && (this.sensorRowCount-2) <= this.oldScopeToId ) {
              // console.log(this.pageSensor.lastValues);
              this.sensorData.push(this.pageSensor.lastValues);
            }
          }
          else {
            this.sensorData.push(this.pageSensor.lastValues);
          }

          if(this.groupBy == "default") {

            this.valuesFiltered.forEach((value, index)=> {
              this.tinkChartData.default[index].data.push({
                x: this.sensorData[this.sensorData.length-1].t.toDate().getTime(),
                y: this.sensorData[this.sensorData.length-1].v[index],
              });
            });

            if(this.zoomLevel == 1) {
              this.tinkChart.config.options.plugins.zoom.limits.x.max = this.sensorData[this.sensorData.length-1].t.toDate().getTime();
            }
            this.tinkOptions._tinkScaleXOriginalMax = this.sensorData[this.sensorData.length-1].t.toDate().getTime();

            // this.$log.info(this.tinkChartData, this.tinkChart);

            (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();
          }


          this.oldScopeFromId = this.scopeFromId;
          this.oldScopeToId = this.scopeToId;

          window.setTimeout(()=>{
            this.showUpdateButton = false
          },3000);

        }

        // 2줄 이상 늘어났다.
        else if((this.sensorRowCount - this.rowCount) > 1) {
          if(this.toastTimer != null) {
            window.clearTimeout(this.toastTimer);
          }
          this.toastTimer = window.setTimeout(()=> {
            this.$parent.$parent.makeToast("info", "데이터 동기화", "한꺼번에 여러 줄의 데이터가 늘어나서 화면을 초기화했습니다.",{
              "autoHideDelay": 5000
            })
          }, 100);
          this.$set(this.$parent.$parent, "pageSensorHistory", {});
          this.$parent.$parent.resetGraph()
        }
      }

      else {
        if((this.lastValuesModified == null && this.pageSensor.lastValuesModified != null)||(this.lastValuesModified != null && this.pageSensor.lastValuesModified == null)||(this.pageSensor != null && this.pageSensor.lastValuesModified != null && this.lastValuesModified != null && this.lastValuesModified.getTime() != this.pageSensor.lastValuesModified.toDate().getTime())) {


          if(this.toastTimer != null) {
            window.clearTimeout(this.toastTimer);
          }
          this.toastTimer = window.setTimeout(()=> {
            this.$parent.$parent.makeToast("danger", "데이터 동기화", "기기 업로드가 꺼진 상태인데 최종 수정일이 바뀌었습니다. 다른 곳에서 웹페이지를 통해서 데이터를 수정한 것 같습니다. 목록을 초기화합니다.", {
              "autoHideDelay": 10000
            })
          }, 100);

          this.$set(this.$parent.$parent, "pageSensorHistory", {});
          this.$parent.$parent.resetGraph();

        }
      }
    }
    else {
      this.groupByDataDirty = true;
    }
  },

  methods: {
    // toCopy
    copyURLWithOptions: function() {
      this.urlWithOptions= this.fullURL + "&pChartOptions=" + encodeURIComponent(JSON.stringify(this.editingOptions));
      this.$root.$emit('bv::show::modal', 'urlWithOptionsModal');
    },

    copyURL: function() {
      this.$copyText(this.fullURL)
      .then(()=> {
        this.$parent.$parent.makeToast("success", "주소 복사 성공", "주소를 클립보드에 복사했습니다.");
      }, (err) => {
        this.$parent.$parent.makeToast("danger", "주소 복사 실패", "주소를 복사하는 중에 에러가 발생했습니다. error:" + err);
      })
    },

    applyColor: function(src) {
      if(src == "backgroudColor") {
        this.editingOptions._tinkBackgroundColor = this.backgroudColorObject.hex8;
      }
      else if(src == "tooltipBackgroudColor") {
        this.editingOptions.plugins.tooltip.backgroundColor = this.tooltipBackgroudColorObject.hex8;
      }
      else if(src == "tooltipBorderColor") {
        this.editingOptions.plugins.tooltip.borderColor = this.tooltipBorderColorObject.hex8;
      }
      else if(src == "tooltipTitleColor") {
        this.editingOptions.plugins.tooltip.titleColor = this.tooltipTitleColorObject.hex8;
      }
      else if(src == "timeScaleGridColor") {
        this.editingOptions._tinkTimeScale.grid.color = this.timeScaleGridColorObject.hex8;
      }
      else if(src == "timeScaleGridBorderColor") {
        this.editingOptions._tinkTimeScale.grid.borderColor = this.timeScaleGridBorderColorObject.hex8;
      }
      else if(src == "timeScaleTitleColor") {
        this.editingOptions._tinkTimeScale.title.color = this.timeScaleTitleColorObject.hex8;
      }
      else if(src == "timeScaleBackgroundColor") {
        this.editingOptions._tinkTimeScale.backgroundColor = this.timeScaleBackgroundColorObject.hex8;
      }
      else if(src == "valueScaleBackgroundColor") {
        this.editingOptions._tinkValueScale.backgroundColor = this.valueScaleBackgroundColorObject.hex8;
      }
    },

    saveChartOptions: function(target) { // user, sensor
      if(target == "user") {
        if(this.isLoginUserPageUser) {
          if(!this.loginUser.chartOptions) {
            this.loginUser.chartOptions = {};
          }
          this.objectMerge(this.loginUser.chartOptions, this.editingOptions);
          this.storeSaveChartOptions();
          this.$parent.$parent.makeToast("info", "내 기본 설정으로 저장함", "설정을 내 기본 설정으로 저장했습니다. 적용하기나 센서에 저장하고 적용하기를 눌러야 현재 그래프에 적용됩니다.", {
            "autoHideDelay": 3000
          });
        }
      }
      else {
        if(this.isLoginUserItemWritable(this.pageSensor)) {
          if(!this.pageSensor.chartOptions) {
            this.pageSensor.chartOptions = {};
          }
        }
        // this.objectMerge(this.pageSensor.chartOptions, this.editingOptions);
        db.collection("sensors").doc(this.pageSensor.id).update({
          "chartOptions": this.editingOptions,
        })
        this.$parent.$parent.makeToast("info", "센서에 그래프 설정을 저장함", "센서에 그래프 설정을 저장하고 현재 그래프에 설정을 적용했습니다. 다음에 들어오면 센서에 저장된 설정이 자동 적용됩니다.", {
          "autoHideDelay": 3000
        });
        this.applyChartOptions(false);
      }
    },

    resetChartDataColor: function() {
      for(let groupBy in this.tinkChartData) {
        if(groupBy == "default") {
          this.tinkChartData[groupBy].forEach((item,index) => {
            this.$set(item, "color", this.tinkOptions._colorList[index].average);
            this.$set(item, "borderColor", this.tinkOptions._colorList[index].average);
          });
        }
        else {
          this.tinkChartData[groupBy].forEach((item,index) => {
            this.$set(item, "color", this.tinkOptions._colorList[item._index][this.typeOptions[item._typeIndex].value]);
            this.$set(item, "borderColor", this.tinkOptions._colorList[item._index][this.typeOptions[item._typeIndex].value]);
          });
        }
      }
    },

    initCanvasContainer: function(update = false) {
      if(this.pHeight != "" && this.pOverflowY == "hidden") {
        this.tinkOptions.maintainAspectRatio = false;
        let subControlHeight = 0;
        let scopeControlHeight = 0;
        if(this.showSubControl) {
          subControlHeight = Math.ceil(this.outerHeight(this.el('subControl')));
        }
        if(this.showScopeControl) {
          scopeControlHeight = Math.ceil(this.outerHeight(this.el('scopeControl')));
        }

        if(this.isLastCharNumber(this.pHeight)) {
          this.el('canvasBox').style.height = (this.pHeight - (window.document.body.clientHeight - this.pHeight) - 24 - subControlHeight - scopeControlHeight ) + "px";
        }
        else if(this.pHeight.endsWith("vh") || this.pHeight.endsWith("%")) {
          let offset = 24 + subControlHeight + scopeControlHeight;
          this.el('canvasBox').style.height = Math.floor(window.document.documentElement.clientHeight*parseInt(this.pHeight)/100 - offset) + "px";
        }
      }
      else {
        let offsetHeight = window.innerHeight - window.document.body.clientHeight  - 24 ;
        let canvasHeight = this.height(this.el('canvasBox'));

        if(this.presentationMode) {
          if(this.tinkOptions._tinkPresentationHeightResizePercent == 0) {
            this.tinkOptions.maintainAspectRatio = true;
          }
          else {
            let newHeight;
            if(offsetHeight >= 0) {
              let resizeMax = Math.round(canvasHeight*this.tinkOptions._tinkPresentationHeightResizePercent/100);
              if(offsetHeight < resizeMax) {
                 newHeight = (this.height(this.el('canvasBox')) + offsetHeight) + "px";
              }
              else {
                newHeight = this.el('canvasBox').style.height = (this.height(this.el('canvasBox')) + resizeMax) + "px";
              }
            }
            else {
              let resizeMin = -1*Math.round(canvasHeight*this.tinkOptions._tinkPresentationHeightResizePercent/100);
              if(offsetHeight < resizeMin) {
                newHeight = this.el('canvasBox').style.height = (this.height(this.el('canvasBox')) + resizeMin) + "px";
              }
              else {
                newHeight = this.el('canvasBox').style.height = (this.height(this.el('canvasBox')) + offsetHeight) + "px";
              }
            }
            this.tinkOptions.maintainAspectRatio = false;
            this.el('canvasBox').style.height = newHeight;
          }
        }
        else {
          if(window.document.documentElement.clientWidth >= window.document.documentElement.clientHeight) {
            this.tinkOptions.maintainAspectRatio = true;
            this.el('canvasBox').style.height = "auto";
          }
          else {
            this.tinkOptions.maintainAspectRatio = false;
            this.el('canvasBox').style.height = getComputedStyle(this.el('canvasBox')).width;
          }
        }
      }

      if(update) {
        (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();
      }
    },

    applyChartOptions: function(showToast=true) {


      if(this.groupBy == "default" && (this.scopeToId - this.scopeFromId) > this.editingOptions._tinkGroupByAutoApplyLength) {
        this.objectMerge(this.tinkOptions, this.editingOptions);
        this.groupBy = "hour";
        this.initPaleColorList();
        this.initChartScales();
        this.resetChartDataColor();
        this.initCanvasContainer();
        this.checkGroupBy();
        this.hideModal('configGraphFloatModal');
      }
      else {
        this.objectMerge(this.tinkOptions, this.editingOptions);
        this.checkPerformanceChartOptions();
        this.initPaleColorList();
        this.initChartScales();
        this.resetChartDataColor();
        this.initCanvasContainer();
        this.applySelectedVisible();
        (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();
        this.setZoomScaleMinMax();
        this.hideModal('configGraphFloatModal');
      }
      // console.log(this.tinkChart);
      if(showToast) {
        this.$parent.$parent.makeToast("info", "수정한 설정을 적용함", "현재 그래프에 설정을 적용했습니다. 다음에 들어왔을 때도 설정이 유지되기를 원하면 그래프 설정하기에서 꼭 센서에 저장하고 적용하기 버튼을 눌러주세요.", {
          "autoHideDelay": 3000
        });
      }
    },

    initSensorData: function() {
      this.sensorData = [];
      for(let i=this.scopeFromIdBook;i<=this.scopeToIdBook;i++) {
        if(typeof(this.$parent.$parent.pageSensorHistory[i]) != "undefined") {
          let startIndex = (i == this.scopeFromIdBook)? this.scopeFromId%1000: 0;
          let endIndex = (i == this.scopeToIdBook)? this.scopeToId%1000: (i == this.lastBook)? Math.min(this.pageSensor.lastIndex, endIndex) :999;
          for(let j=startIndex;j<=endIndex;j++) {
            this.sensorData.push(this.$parent.$parent.pageSensorHistory[i].data[j]);
          }
        }
      }
      this.valuesFiltered.forEach((value,index)=> {
        if(value.type == "FLOAT_VAL") {
          let perDiff = Math.floor(Math.log10((value.diff)? 1/value.diff: 1/0.01));
          this.sensorData.forEach((item)=> {
            item.v[index] = this.roundValue(item.v[index], perDiff);
          })
        }
      });
    },
    resetTinkChartData: function(target) {
      if(typeof(target) == "undefined") {
        for(let groupBy in this.columnsOptions) {
          this.tinkChartData[groupBy].forEach(item => {
            item.data = [];
          });
        }
      }
      else if(typeof(this.tinkChartData[target]) != "undefined") {
        this.tinkChartData[target].forEach(item => {
          item.data = [];
        });
      }
    },

    initTinkChartData: function() {
      for(let groupBy in this.columnsOptions) {
        if(groupBy == "default") {
          for(let valueName in this.columnsOptions[groupBy]) {
            let toAdd = {};
            this.objectMerge(toAdd, this.defaultDataset);
            merge(toAdd, {
              "label": this.columnsOptions[groupBy][valueName].text,
              "color": this.tinkOptions._colorList[this.columnsOptions[groupBy][valueName].index].average,
              "borderColor": this.tinkOptions._colorList[this.columnsOptions[groupBy][valueName].index].average,
              "backgroundColor": this.tinkPaleColorList[this.columnsOptions[groupBy][valueName].index].average,
              "yAxisID": valueName,
              "_value": valueName,
              "_index": this.columnsOptions[groupBy][valueName].index,
            });
            this.tinkChartData[groupBy].push(toAdd);
          }
        }
        else {
          for(let valueName in this.columnsOptions[groupBy]) {
            for(let type in this.columnsOptions[groupBy][valueName]) {
              let toAdd = {};
              this.objectMerge(toAdd, this.defaultDataset);
              merge(toAdd, {
                "label": this.columnsOptions[groupBy][valueName][type].fullText,
                "color": this.tinkOptions._colorList[this.columnsOptions[groupBy][valueName][type].index][type],
                "borderColor": this.tinkOptions._colorList[this.columnsOptions[groupBy][valueName][type].index][type],
                "backgroundColor": this.tinkPaleColorList[this.columnsOptions[groupBy][valueName][type].index][type],
                "yAxisID": valueName + "_" + type,
                "_value": valueName,
                "_type": type,
                "_index": this.columnsOptions[groupBy][valueName][type].index,
                "_typeIndex": this.columnsOptions[groupBy][valueName][type].typeIndex,
              });
              this.tinkChartData[groupBy].push(toAdd);
            }
          }
        }
      }
      // this.$log.info("tinkChartData", this.tinkChartData);
    },

    makeGroupByData: function(groupBy) {
      if(typeof(groupBy) == "undefined" || groupBy == "default") {
        return;
      }

      let perDiffs = [];
      this.valuesFiltered.forEach((value,index)=> {
        perDiffs.push((value.type == "FLOAT_VAL")? Math.floor(Math.log10((value.diff)? 1/value.diff: 1/0.01)) : null);
      });

      this.tinkOptions._tinkDataReady = false;

      let groupByResult = {};
      if(groupBy == "hour") {
        this.sensorData.forEach(item=> {
          let itemDate = item.t.toDate();
          itemDate.setMilliseconds(0);
          itemDate.setSeconds(0);
          itemDate.setMinutes(0);
          let itemDateEpochSeconds = Math.floor(itemDate.getTime()/1000);

          if(typeof(groupByResult[itemDateEpochSeconds+""]) == "undefined") {
            groupByResult[itemDateEpochSeconds+""] = [];
            this.valuesFiltered.forEach((value,index)=> {
              groupByResult[itemDateEpochSeconds+""].push([]);
            });
          }
          this.valuesFiltered.forEach((value,index)=> {
            groupByResult[itemDateEpochSeconds+""][index].push(item.v[index]);
          });
        })
      }
      else if(groupBy == "date") {
        this.sensorData.forEach(item=> {
          let itemDate = item.t.toDate();
          itemDate.setMilliseconds(0);
          itemDate.setSeconds(0);
          itemDate.setMinutes(0);
          itemDate.setHours(0);
          let itemDateEpochSeconds = Math.floor(itemDate.getTime()/1000);
          if(typeof(groupByResult[itemDateEpochSeconds+""]) == "undefined") {
            groupByResult[itemDateEpochSeconds+""] = [];
            this.valuesFiltered.forEach((value,index)=> {
              groupByResult[itemDateEpochSeconds+""].push([]);
            });
          }
          this.valuesFiltered.forEach((value,index)=> {
            groupByResult[itemDateEpochSeconds+""][index].push(item.v[index]);
          });
        })
      }
      else if(groupBy == "month") {
        this.sensorData.forEach(item=> {
          let itemDate = item.t.toDate();
          itemDate.setMilliseconds(0);
          itemDate.setSeconds(0);
          itemDate.setMinutes(0);
          itemDate.setHours(0);
          itemDate.setDate(1);
          let itemDateEpochSeconds = Math.floor(itemDate.getTime()/1000);
          if(typeof(groupByResult[itemDateEpochSeconds+""]) == "undefined") {
            groupByResult[itemDateEpochSeconds+""] = [];
            this.valuesFiltered.forEach((value,index)=> {
              groupByResult[itemDateEpochSeconds+""].push([]);
            });
          }
          this.valuesFiltered.forEach((value,index)=> {
            groupByResult[itemDateEpochSeconds+""][index].push(item.v[index]);
          });
        })
      }

      // tinkOptions.plugins.zoom.limits

      const arraySum = (accumulator, curr) => accumulator + curr;
      let minResult = [];
      let maxResult = [];
      this.valuesFiltered.forEach(()=> {
        minResult.push(null);
        maxResult.push(null);
      });

      for(let dt in groupByResult) {
        this.valuesFiltered.forEach((value,index)=> {
          groupByResult[dt][index].sort();

          if(perDiffs[index] != null) {
            if(groupByResult[dt][index].length > 0) {
              // min
              let min = groupByResult[dt][index][0];
              this.tinkChartData[groupBy][this.valueTypeList["min"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: min,
              });
              if(minResult[index]==null||minResult[index]>min) {
                minResult[index] = min;
              }
              // max
              let max = groupByResult[dt][index][groupByResult[dt][index].length-1];
              this.tinkChartData[groupBy][this.valueTypeList["max"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: max,
              });
              if(maxResult[index]==null||maxResult[index]<min) {
                maxResult[index] = max;
              }
            }
            if(groupByResult[dt][index].length == 1) {
              // median
              this.tinkChartData[groupBy][this.valueTypeList["median"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: groupByResult[dt][index][0]
              });
            }
            else if(groupByResult[dt][index].length%2 == 0) {
              let half = groupByResult[dt][index].length/2;
              // median
              this.tinkChartData[groupBy][this.valueTypeList["median"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: this.roundValue((groupByResult[dt][index][half-1] + groupByResult[dt][index][half])/2),
              });

            }
            else {
              let half = Math.floor(groupByResult[dt][index].length/2);
              // median:
              this.tinkChartData[groupBy][this.valueTypeList["median"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: groupByResult[dt][index][half],
              });
            }
            let sum = groupByResult[dt][index].reduce(arraySum);
            let count = groupByResult[dt][index].length;
            // sum: groupByResult[dt][index].reduce(arraySum)
            this.tinkChartData[groupBy][this.valueTypeList["sum"].index + index*this.typeOptions.length].data.push({
              x: dt*1000,
              y: this.roundValue(sum, perDiffs[index]),
            });
            this.tinkChartData[groupBy][this.valueTypeList["count"].index + index*this.typeOptions.length].data.push({
              x: dt*1000,
              y: count,
            });
            this.tinkChartData[groupBy][this.valueTypeList["average"].index + index*this.typeOptions.length].data.push({
              x: dt*1000,
              y: this.roundValue(sum/count, perDiffs[index]),
            });
          }
          else {
            if(groupByResult[dt][index].length > 0) {
              // min
              let min = groupByResult[dt][index][0];
              this.tinkChartData[groupBy][this.valueTypeList["min"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: min,
              });
              if(minResult[index]==null||minResult[index]>min) {
                minResult[index] = min;
              }
              // max
              let max = groupByResult[dt][index][groupByResult[dt][index].length-1];
              this.tinkChartData[groupBy][this.valueTypeList["max"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: max,
              });
              if(maxResult[index]==null||maxResult[index]>min) {
                maxResult[index] = max;
              }
            }
            if(groupByResult[dt][index].length == 1) {
              // median
              this.tinkChartData[groupBy][this.valueTypeList["median"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: groupByResult[dt][index][0],
              });
            }
            else if(groupByResult[dt][index].length%2 == 0) {
              let half = groupByResult[dt][index].length/2;
              // median
              this.tinkChartData[groupBy][this.valueTypeList["median"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: (groupByResult[dt][index][half-1] + groupByResult[dt][index][half])/2,
              });

            }
            else {
              let half = Math.floor(groupByResult[dt][index].length/2);
              // median:
              this.tinkChartData[groupBy][this.valueTypeList["median"].index + index*this.typeOptions.length].data.push({
                x: dt*1000,
                y: groupByResult[dt][index][half],
              });
            }
            let sum = groupByResult[dt][index].reduce(arraySum);
            let count = groupByResult[dt][index].length;
            // sum: groupByResult[dt][index].reduce(arraySum)
            this.tinkChartData[groupBy][this.valueTypeList["sum"].index + index*this.typeOptions.length].data.push({
              x: dt*1000,
              y: sum,
            });
            this.tinkChartData[groupBy][this.valueTypeList["count"].index + index*this.typeOptions.length].data.push({
              x: dt*1000,
              y: count,
            });
            this.tinkChartData[groupBy][this.valueTypeList["average"].index + index*this.typeOptions.length].data.push({
              x: dt*1000,
              y: sum/count,
            });
          }
        });
      }

      this.valuesFiltered.forEach((value,index)=> {
        ["max", "min", "average", "median"].forEach(type=> {
          this.tinkOptions.scales[value.name + "_" + type].max = maxResult[index];
          this.tinkOptions.scales[value.name + "_" + type].min = minResult[index];
          this.tinkOptions.scales[value.name + "_" + type].suggestedMax = maxResult[index];
          this.tinkOptions.scales[value.name + "_" + type].suggestedMin = minResult[index];
        })
      });

      // this.tinkChart.config.data.datasets = this.tinkChartData[this.groupBy];
      // this._tinkDataReady = true;
      // this.applySelectedVisible();
      // this.resetZoom();
      // this.tinkChart.update();
      // this.setZoomScaleMinMax();
      // this.$log.info("tinkChartData", this.tinkChartData);
    },

    checkGroupBy: function() {

      if(this.groupBy == "default" && this.groupByDataDirty) {
        // this.$set(this.$parent.$parent, "pageSensorHistory", {});
        this.$parent.$parent.resetGraph();
      }
      else {

        this.tinkOptions._tinkDataReady = false;

        if(this.groupBy != "default" && this.tinkChartData[this.groupBy].length != 0 && this.tinkChartData[this.groupBy][0].data.length == 0) {
          this.makeGroupByData(this.groupBy);
        }

        this.checkPerformanceChartOptions();
        this.tinkChart.config.data.datasets = this.tinkChartData[this.groupBy];
        this.tinkOptions._tinkDataReady = true;
        this.resetZoom();
        this.initChartScales();
        this.applySelectedVisible();
        (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();
        this.setZoomScaleMinMax();
        this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
        this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
        this.tinkOptions._tinkScaleXOriginalMin = this.tinkChart.scales.x.min;
        this.tinkOptions._tinkScaleXOriginalMax = this.tinkChart.scales.x.max;

        // this.$log.info(this.tinkChart, this.tinkChartConfig, this.tinkChartData);

      }


    },

    setChartMessagePosition: function() {
      this.el("chartMessage").style.top = (this.top(this.el("chartMessage")) + this.height(this.el("chartBox"))/4 - this.height(this.el("chartMessage"))/4) + "px";

      this.el("chartMessage").style.left = (this.left(this.el("chartMessage")) + this.width(this.el("chartBox"))/2 - this.width(this.el("chartMessage"))/2) + "px";
    },

    scopeFromIdChanged: function() {
      if(this.el("scopeFromId") != null && this.el("scopeFromId").checkValidity()) {
        this.scopeFromDateSelected = false;
        this.scopeFromDate = this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000));
      }
    },

    scopeToIdChanged: function() {
      if(this.el("scopeToId") != null && this.el("scopeToId").checkValidity()) {
        this.scopeToDateSelected = false;
        this.scopeToDate = this.toISOString(new Date(this.scopeToIdEpochSeconds*1000));
      }
    },

    onZoomComplete() {
      this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
    },

    onPanComplete() {
      this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
    },

    resetZoom: function() {
      this.toggleZoom(true);
      this.tinkChart.resetZoom();
      this.initChartScales();
      (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();

      /*
      this.objectMerge(this.tinkOptions, this.editingOptions);
      this.checkPerformanceChartOptions();
      this.initPaleColorList();
      this.initChartScales();
      this.resetChartDataColor();
      this.initCanvasContainer();
      this.applySelectedVisible();
      (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();
      this.setZoomScaleMinMax();
      this.hideModal('configGraphFloatModal');
      this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
      this.tinkOptions._tinkScaleXOriginalMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXOriginalMax = this.tinkChart.scales.x.max;
      */

      // this.tinkChart.zoomScale('x', {min: this.tinkOptions._tinkScaleXOriginalMin, max: this.tinkOptions._tinkScaleXOriginalMax}, 'default');

      this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
    },

    panLeft: function() {
      this.tinkChart.pan(Math.floor(this.tinkChart.width/10));
    },

    panRight: function() {
      this.tinkChart.pan(-Math.floor(this.tinkChart.width/10));
    },

    zoomIn: function() {
      if(this.zoomLevel > 0.1) {
        this.tinkChart.zoom(2 - Math.max(0.1,(this.zoomLevel-0.1))/this.zoomLevel);
        this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
        this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
      }
      else if(this.zoomLevel <= 0.1 && this.zoomLevel > 0.01) {
        this.tinkChart.zoom(2 - Math.max(0.01,(this.zoomLevel-0.01))/this.zoomLevel);
        this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
        this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
      }
    },

    zoomOut: function() {
      if(this.zoomLevel < 0.1) {
        this.tinkChart.zoom(2 - (this.zoomLevel+0.01)/this.zoomLevel);
        this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
        this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
      }
      else if(this.zoomLevel < 0.9) {
        this.tinkChart.zoom(2 - (this.zoomLevel+0.1)/this.zoomLevel);
        this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
        this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
      }
      else {
        this.resetZoom();
      }
    },

    toggleZoom: function(tinkZoomEnabled) {
      if(typeof(tinkZoomEnabled) == "undefined") {
        var tinkZoomEnabled = !this.tinkOptions._tinkZoomEnabled;
      }
      this.tinkOptions._tinkZoomEnabled = tinkZoomEnabled;

      if(this.tinkOptions._tinkZoomEnabled) {
        this.tinkChart.config.options.plugins.zoom.zoom.drag.enabled = true;
        this.tinkChart.config.options.plugins.zoom.zoom.pinch.enabled = true;
        this.tinkChart.config.options.plugins.zoom.zoom.wheel.enabled = true;
        this.tinkChart.config.options.plugins.zoom.pan.enabled = false;
        this.tinkChart.zoom(1);
      }
      else {
        this.tinkChart.config.options.plugins.zoom.zoom.drag.enabled = false;
        this.tinkChart.config.options.plugins.zoom.zoom.pinch.enabled = false;
        this.tinkChart.config.options.plugins.zoom.zoom.wheel.enabled = false;
        this.tinkChart.config.options.plugins.zoom.pan.enabled = true;
        this.tinkChart.pan(1);
      }

    },

    applyColumnsSelected: function() {

      if(this.groupBy == "default") {
        this.applySelectedVisible();
        // this.resetZoom();
        (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();
        this.setZoomScaleMinMax();
      }
      else {
        this.applySelectedVisible();
        // this.resetZoom();
        (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();
        this.setZoomScaleMinMax();
      }
    },

    initChart: function() {
      this.tinkChartElement = this.el("tinkChart");
      this.tinkChart = new Chart(this.tinkChartElement, this.tinkChartConfig);
      this.initPaleColorList();
      this.initChartOptions();
      if(this.pChartOptions == "") {
        this.initChartScales();
        this.applySelectedVisible();
      }
      this.initTinkChartData();
    },

    initPaleColorList: function() {
      let paleColorList = [];
      this.tinkOptions._colorList.forEach(item => {
        paleColorList.push({});
        for(let type in item) {
          paleColorList[paleColorList.length-1][type] = item[type] + this.tinkOptions._tinkPaleColorOpacity.toString(16);
        }
      });
      this.tinkPaleColorList = paleColorList;
    },

    loadChartConfig: function(source) {
      if(source == "user") {
        if(this.isLoginUserPageUser && this.loginUser.chartOptions) {
          this.objectMerge(this.editingOptions, this.loginUser.chartOptions);
        }
        this.$parent.$parent.makeToast("info", "내 그래프 기본 설정을 불러옴", "내 그래프 기본 설정을 불러왔습니다. 하단의 테스트 적용하기나 저장하고 적용하기를 눌러야 반영됩니다.", {
          "autoHideDelay": 3000
        });
      }
      else if(source == "sensor") {
        if(this.isLoginUserItemWritable(this.pageSensor) && this.pageSensor.chartOptions) {
          this.objectMerge(this.editingOptions, this.pageSensor.chartOptions);
        }
        this.$parent.$parent.makeToast("info", "센서에 저장된 그래프 설정을 불러옴", "센서에 저장된 그래프 설정을 불러왔습니다. 하단의 테스트 적용하기나 저장하고 적용하기를 눌러야 반영됩니다.", {
          "autoHideDelay": 3000
        });
      }
      else if(source == "performance") {
        this.objectMerge(this.editingOptions, this.performanceOptions);
        this.$parent.$parent.makeToast("info", "그래프 성능 우선 설정을 불러옴", "그래프 성능 우선 설정을 불러왔습니다. 하단의 테스트 적용하기나 저장하고 적용하기를 눌러야 반영됩니다.", {
          "autoHideDelay": 3000
        });
      }
      else if(source == "default") {
        this.objectMerge(this.editingOptions, this.defaultEditingOptions);
        this.$parent.$parent.makeToast("info", "그래프 기본 설정을 불러옴", "그래프 기본 설정을 불러왔습니다. 하단의 테스트 적용하기나 저장하고 적용하기를 눌러야 반영됩니다.", {
          "autoHideDelay": 3000
        });
      }
    },

    checkPerformanceChartOptions: function() {
      if(this.groupBy != "default") {
        this.performanceMode = false;
        this.objectMerge(this.tinkOptions, this.defaultEditingOptions);
        if(this.loginUserPageUser && this.loginUser.chartOptions) {
          this.objectMerge(this.tinkOptions, this.loginUser.chartOptions);
        }
        if(this.pageSensor.chartOptions) {
          this.objectMerge(this.tinkOptions, this.pageSensor.chartOptions);
        }
      }
      else {
        if(!this.performanceMode && (this.scopeToId - this.scopeFromId) > this.tinkOptions._tinkPerformanceAutoApplyLength) {
          this.performanceMode = true;
          this.objectMerge(this.tinkOptions, this.performanceOptions);
        }

        if(this.performanceMode && (this.scopeToId - this.scopeFromId) <= this.tinkOptions._tinkPerformanceAutoApplyLength) {
          this.performanceMode = false;
          this.objectMerge(this.tinkOptions, this.defaultEditingOptions);
          if(this.loginUserPageUser && this.loginUser.chartOptions) {
            this.objectMerge(this.tinkOptions, this.loginUser.chartOptions);
          }
          if(this.pageSensor.chartOptions) {
            this.objectMerge(this.tinkOptions, this.pageSensor.chartOptions);
          }
        }
      }
    },

    initChartOptions: function() {

      if(this.loginUserPageUser && this.loginUser.chartOptions) {
        this.objectMerge(this.tinkOptions, this.loginUser.chartOptions);
        this.objectMerge(this.editingOptions, this.loginUser.chartOptions);
      }
      if(this.pageSensor.chartOptions) {
        this.objectMerge(this.tinkOptions, this.pageSensor.chartOptions);
        this.objectMerge(this.editingOptions, this.pageSensor.chartOptions);
      }

      if(this.pChartOptions != "") {
        try {
          let customOptions = JSON.parse(this.pChartOptions);
          this.objectMerge(this.tinkOptions, customOptions);
          this.objectMerge(this.editingOptions, customOptions);
        }
        catch(error) {
          console.log(error);
        }
      }
      this.tooltipBackgroudColorObject = this.editingOptions.plugins.tooltip.backgroundColor;
      this.tooltipBorderColorObject = this.editingOptions.plugins.tooltip.borderColor;
      this.tooltipTitleColorObject =  this.editingOptions.plugins.tooltip.titleColor;
      this.timeScaleGridColorObject = this.editingOptions._tinkTimeScale.grid.color;
      this.timeScaleGridBorderColorObject = this.editingOptions._tinkTimeScale.grid.borderColor;
      this.timeScaleTitleColorObject = this.editingOptions._tinkTimeScale.title.color;
      this.timeScaleBackgroundColorObject = this.editingOptions._tinkTimeScale.backgroundColor;
      this.valueScaleBackgroundColorObject = this.editingOptions._tinkValueScale.backgroundColor;
    },

    initChartScales: function() {
      let result = {};
      let xAxe = {};
      merge(xAxe, this.tinkOptions._tinkTimeScale);
      result["x"] = xAxe;
      for(let groupBy in this.columnsOptions) {
        if(groupBy == "default") {
          for(let valueName in this.columnsOptions.default) {
            let yAxe = {};
            merge(yAxe, this.tinkOptions._tinkValueScale);
            // console.log(this.tinkOptions._colorList, this.columnsOptions.default[valueName]);
            merge(yAxe, {
              "position": (this.columnsOptions.default[valueName].index%2 == 0)? "left": "right",
              "id": valueName,
              "title": {
                "text": this.columnsOptions.default[valueName].text ,
                "color": this.tinkOptions._colorList[this.columnsOptions.default[valueName].index].average,
              },
              "grid": {
                "color": this.tinkPaleColorList[this.columnsOptions.default[valueName].index].average,
                "borderColor": this.tinkOptions._colorList[this.columnsOptions.default[valueName].index].average,
              },
              "ticks": {
                "color": this.tinkOptions._colorList[this.columnsOptions.default[valueName].index].average,
              }
            });
            result[valueName] = yAxe;
          }
        }
        else {
          let valueIndex = 0;
          for(let valueName in this.columnsOptions[groupBy]) {
            for(let type in this.columnsOptions[groupBy][valueName]) {
              let yAxeName = valueName + "_" + type;
              let yAxe = {};
              merge(yAxe, this.tinkOptions._tinkValueScale);
              merge(yAxe, {
                "position":
                ((valueIndex*this.typeOptions.length + this.columnsOptions[groupBy][valueName][type].typeIndex)%2 == 0)? "left": "right",
                "id": yAxeName,
                "title": {
                  "text": this.columnsOptions[groupBy][valueName][type].fullText ,
                  "color": this.tinkOptions._colorList[this.columnsOptions[groupBy][valueName][type].index][type],
                },
                "grid": {
                  "color": this.tinkPaleColorList[this.columnsOptions[groupBy][valueName][type].index][this.columnsOptions[groupBy][valueName][type].typeIndex],
                  "borderColor": this.tinkOptions._colorList[this.columnsOptions[groupBy][valueName][type].index][type],
                },
                "ticks": {
                  "color": this.tinkOptions._colorList[this.columnsOptions[groupBy][valueName][type].index][type],
                }
              });
              result[yAxeName] = yAxe;
            }
            valueIndex++;
          }
        }
      }
      this.$set(this.tinkOptions, "scales", result);


    },
    setZoomScaleMinMax: function() {

      let selectedList = this.getSelectedList();
      let zoomLimits = {};

      /*
      this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
      this.tinkOptions._tinkScaleXOriginalMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXOriginalMax = this.tinkChart.scales.x.max;
      */

      for(let scaleId in this.tinkOptions.scales) {
        if(scaleId == "x") {
          zoomLimits[scaleId] = {
            min: this.tinkOptions._tinkScaleXOriginalMin,
            max: this.tinkOptions._tinkScaleXOriginalMax
          };
        }
        else if(selectedList[scaleId] === true) {
          zoomLimits[scaleId] = {
            min: this.tinkChart.scales[scaleId].min,
            max: this.tinkChart.scales[scaleId].max
          };
        }
      }
      this.tinkChart.config.options.plugins.zoom.limits = zoomLimits;
    },
    getSelectedList : function() {
      let selectedList = {};
      for(let groupBy in this.columns) {
        if(groupBy == "default" && groupBy == this.groupBy) {
          this.columns.default.forEach(item => {
            selectedList[item] = true;
          })
        }
        else if(groupBy == this.groupBy) {
          for(let valueName in this.columns[groupBy]) {
            this.columns[groupBy][valueName].forEach(item => {
              selectedList[valueName + "_" + item] = true;
            })
          }
        }
      }
      return selectedList;
    },
    applySelectedVisible: function() {
      let selectedList = this.getSelectedList();

      for(let scaleId in this.tinkOptions.scales) {
        if(selectedList[scaleId] === true) {
          this.tinkOptions.scales[scaleId].display = true;
        }
        else if(scaleId != "x") {
          this.tinkOptions.scales[scaleId].display = false;
        }
      }
      this.tinkChartData[this.groupBy].forEach(item=>{
        item.hidden = (selectedList[item.yAxisID] === true)? false: true;
      })

    },

    moveScopeLeft: function() {

      let newScopeFromId = Math.max(0, Math.floor((this.scopeFromId - (this.scopeToIdBook - this.scopeFromIdBook + 1)*1000)/1000)*1000);
      let newScopeToId = this.scopeFromId-1;
      if(newScopeFromId != this.scopeFromId) {
        this.scopeFromId = newScopeFromId;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeFromDateSelected = false;
        this.scopeToId = newScopeToId;
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
        if(this.dataUpdateNeeded) {
          this.getData();
        }
      }

    },

    moveScopeRight: function() {
      let newScopeFromId = this.scopeToId + 1;

      let newScopeToId = Math.min(this.pageSensor.lastBook*1000 + this.pageSensor.lastIndex, (this.scopeToIdBook+1)*1000-1 + (this.scopeToIdBook - this.scopeFromIdBook + 1)*1000);

      if(newScopeToId != this.scopeToId) {
        this.scopeFromId = newScopeFromId;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeFromDateSelected = false;
        this.scopeToId = newScopeToId;
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
        if(this.dataUpdateNeeded) {
          this.getData();
        }
      }
    },

    cancelScopeChanged: function() {
      this.scopeFromId = this.oldScopeFromId;
      this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
      this.scopeToId = this.oldScopeToId;
      this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
      this.updateSliderValues();
      this.updateStep();
    },

    applyScopeChanged: function() {
      if(this.el("scopeFromId") != null && !this.el("scopeFromId").checkValidity()) {
        this.el("scopeFromId").focus();
        return;
      }
      else if(this.el("scopeToId") != null && !this.el("scopeToId").checkValidity()) {
        this.el("scopeToId").focus();
        return;
      }
      else {
        this.getData(false);
      }
    },

    scopeFromDateInput: function(date) {

      if(date != "") {
        let fromDate = new Date(date);
        if(fromDate.getSeconds() != 0) {
          fromDate.setSeconds(0);
        }

        let fromId = null;
        let fromIdSameBook = false;

        if(fromDate && (this.pageSensor.lastBook != 0 || this.pageSensor.lastIndex != -1)) {

          let epochSeconds = Math.floor(fromDate.getTime()/1000);
          let foundBook = 0;

          if(epochSeconds < this.pageSensor.bookInfo[0].from.seconds) {
            foundBook = -1;
          }
          else if(epochSeconds > this.pageSensor.bookInfo[this.pageSensor.lastBook].to.seconds) {
            foundBook = this.pageSensor.lastBook+1;
          }
          else {
            for(let i=0;i<=this.pageSensor.lastBook;i++) {
              if(epochSeconds <= this.pageSensor.bookInfo[i].to.seconds) {
                foundBook = i;
                break;
              }
            }
          }

          if(foundBook < 0) {
            fromId = 0;
            this.scopeFromDateSelected = false;
          }
          else if(foundBook > this.pageSensor.lastBook) {
            fromId = this.sensorRowCount-1;
            this.scopeFromDateSelected = false;
          }
          else {
            if(this.$parent.$parent.pageSensorHistory[foundBook]) {
              let lastIndex = (foundBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999;
              for(let i=0;i<=lastIndex;i++) {
                if(this.$parent.$parent.pageSensorHistory[foundBook].data[""+i].t.seconds >= epochSeconds) {
                  fromId = foundBook*1000 + i;
                  this.scopeFromDateSelected = false;
                  break;
                }
              }
            }
            else {
              fromId = foundBook*1000;
              this.scopeFromDateSelected = true;
            }
          }
        }

        if(fromId !== null) {
          this.scopeFromId = fromId;
          this.scopeFromDate = this.toISOString(fromDate);
          this.updateSliderValues();
        }
      }
    },

    scopeToDateInput: function(date) {
      if(date != "") {
        let toDate = new Date(date);
        if(toDate.getSeconds() != 0) {
          toDate.setSeconds(0);
        }
        let toId = null;
        if(toDate && (this.pageSensor.lastBook != 0 || this.pageSensor.lastIndex != -1)) {
          let epochSeconds = Math.floor((new Date(this.scopeToDate)).getTime()/1000);
          let foundBook = 0;
          if(epochSeconds < this.pageSensor.bookInfo[0].from.seconds) {
            foundBook = -1;
          }
          else if(epochSeconds > this.pageSensor.bookInfo[this.pageSensor.lastBook].to.seconds) {
            foundBook = this.pageSensor.lastBook+1;
          }
          else {
            for(let i=this.pageSensor.lastBook;i>=0;i--) {
              if(epochSeconds >= this.pageSensor.bookInfo[i].from.seconds) {
                foundBook = i;
                break;
              }
            }
          }

          if(foundBook < 0) {
            toId = 0;
            this.scopeToDateSelected = false;
          }
          else if(foundBook > this.pageSensor.lastBook) {
            toId = this.sensorRowCount-1;
            this.scopeToDateSelected = false;
          }
          else {
            if(this.$parent.$parent.pageSensorHistory[foundBook]) {
              let lastIndex = (foundBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999;
              for(let i=lastIndex;i>=0;i--) {
                if(this.$parent.$parent.pageSensorHistory[foundBook].data[""+i].t.seconds <= epochSeconds) {
                  toId = foundBook*1000 + i;
                  this.scopeToDateSelected = false;
                  break;
                }
              }
            }
            else {
              toId = foundBook*1000 + ((foundBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999);
              this.scopeToDateSelected = true;
            }
          }
        }

        if(toId !== null) {
          this.scopeToId = toId;
          this.scopeToDate = this.toISOString(toDate);
          this.updateSliderValues();
        }
      }
    },

    previousScopeFromId: function() {

      if(this.scopeFromIdStart != this.scopeFromId) {
        this.scopeFromId = this.scopeFromIdStart;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeFromDateSelected = false;
        this.updateSliderValues();
      }
      else {
        if(this.scopeFromId >= 1000) {
          this.scopeFromId = this.scopeFromId  - 1000;
          this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
          this.scopeFromDateSelected = false;
          this.updateSliderValues();
        }
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    nextScopeFromId: function() {
      if((this.scopeFromIdStart+1000) < this.scopeToId) {
        this.scopeFromId = this.scopeFromIdStart+1000;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
        // this.sensorGridRefresh();
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    previusScopeToId: function() {
      if(this.scopeToIdEnd == (this.sensorRowCount-1)) {
        let result = Math.floor(this.scopeToId/1000)*1000-1;
        if(result > 0 && result > this.scopeFromId) {
          this.scopeToId = result;
          this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
          this.scopeToDateSelected = false;
          this.updateSliderValues();
        }
      }
      else {
        let result = this.scopeToIdEnd-1000;
        if(result > 0 && result > this.scopeFromId) {
          this.scopeToId = result;
          this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
          this.scopeToDateSelected = false;
          this.updateSliderValues();
        }
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    nextScopeToId: function() {

      if(this.scopeToId == this.scopeToIdEnd) {
        this.scopeToId = Math.min(this.scopeToIdEnd + 1000, this.sensorRowCount-1);
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
      }
      else {
        this.scopeToId = this.scopeToIdEnd;
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
        this.scopeToDateSelected = false;
        this.updateSliderValues();
      }
      if(this.dataUpdateNeeded) {
        this.getData();
      }
    },

    toggleSliderShow: function() {
      if(this.sliderShow) this.sliderShow = false;
      else this.sliderShow = true;
    },
    focusElement: function(id) {
      if(this.el(id)) {
        this.el(id).focus();
      }
    },

    initScope: function() {

      if(this.pToId != null) {
        if(this.pToId >= this.sensorRowCount) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToId가 너무 큽니다. 범위의 끝을 최대값으로 지정했습니다.");
          this.scopeToId = this.sensorRowCount-1;
        }
        else if(this.pToId < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToId가 음수입니다. 범위의 끝을 0으로 지정했습니다.");
          this.scopeToId = 0;
        }
        else {
          this.scopeToId = this.pToId;
        }
      }
      else if(this.pToBook != null) {
        if(this.pToBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToBook이 너무 큽니다. 범위의 끝을 최대값으로 지정했습니다.");
          this.scopeToId = this.lastBook*1000 + this.lastIndex;
        }
        else if(this.pToBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToBook이 음수입니다. 범위의 끝을 0으로 지정했습니다.");
          this.scopeToId = 0;
        }
        else {
          this.scopeToId = Math.min(this.pToBook*1000+999, this.lastBook*1000 + this.lastIndex);
        }
      }
      else if(this.pToDateEpoch != null) {
        // 2021.06.08 18:41:36 = 1623145296
        let pToDate = new Date(this.pToDateEpoch*1000);
        let foundBook = this.findBookIncludesDate(pToDate);
        // this.$log.info(pToDate, foundBook);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToDateEpoch가 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = 0;
          this.scopeToDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = this.lastBook*1000 + this.lastIndex;
          this.scopeToDateSelected = false;
        }
        else {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = Math.min(foundBook*1000 + 999, this.lastBook*1000 + this.lastIndex);
          this.scopeToDateSelected = true;
        }
      }
      else if(this.pToDate != "") {
        let pToDate = new Date(this.pToDate);
        let foundBook = this.findBookIncludesDate(pToDate);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pToDate 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = 0;
          this.scopeToDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = this.lastBook*1000 + this.lastIndex;
          this.scopeToDateSelected = false;
        }
        else {
          this.scopeToDate = this.toISOString(pToDate);
          this.scopeToId = Math.min(foundBook*1000 + 999, this.lastBook*1000 + this.lastIndex);
          this.scopeToDateSelected = true;
        }
      }

      /*
      pFromId: { type: Number, default: null },
      pFromBook: { type: Number, default: null },
      pFromDateEpoch: { type: Number, default: null },
      pFromDate: { type: String, default: "" },
      */

      if(this.pFromId != null) {
        if(this.pFromId >= this.sensorRowCount) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromId가 너무 큽니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromId = this.sensorRowCount-1;
        }
        else if(this.pFromId < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromId가 음수입니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromId = 0;
        }
        else {
          this.scopeFromId = this.pFromId;
        }
      }
      else if(this.pFromBook != null) {
        if(this.pFromBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromBook이 너무 큽니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromId = this.lastBook*1000 + this.lastIndex;
        }
        else if(this.pFromBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromBook이 음수입니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromId = 0;
        }
        else {
          this.scopeFromId = Math.min(this.pFromBook*1000, this.lastBook*1000 + this.lastIndex);
        }
      }
      else if(this.pFromDateEpoch != null) {
        // 2021.06.08 18:41:36 = 1623145296
        let pFromDate = new Date(this.pFromDateEpoch*1000);
        let foundBook = this.findBookIncludesDate(pFromDate);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDateEpoch가 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDateEpoch가 너무 작습니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = 0;
          this.scopeFromDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDateEpoch가 너무 큽니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = this.lastBook*1000 + this.lastIndex;
          this.scopeFromDateSelected = false;
        }
        else {
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = foundBook*1000;
          this.scopeFromDateSelected = true;
        }
      }
      else if(this.pFromDate != "") {
        let pFromDate = new Date(this.pFromDate);
        let foundBook = this.findBookIncludesDate(pFromDate);
        if(foundBook == null) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDate가 잘못된 값입니다.");
        }
        else if(foundBook < 0) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDate가 너무 과거입니다. 범위의 시작을 0으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = 0;
          this.scopeFromDateSelected = false;
        }
        else if(foundBook > this.lastBook) {
          this.makeToast("info", "범위가 잘못되었습니다.", "pFromDate가 데이터 최종 수정일보다 미래입니다. 범위의 시작을 최대값으로 지정했습니다.");
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = this.lastBook*1000 + this.lastIndex;
          this.scopeFromDateSelected = false;
        }
        else {
          this.scopeFromDate = this.toISOString(pFromDate);
          this.scopeFromId = foundBook*1000;
          this.scopeFromDateSelected = true;
        }
      }

      if(this.scopeFromId != null && this.scopeToId != null && (this.scopeFromId > this.scopeToId)) {
        this.makeToast("danger", "범위가 잘못되었습니다.", "범위의 시작이 범위의 끝보다 큽니다. 표를 비활성화합니다.");
        this.gridDisabled = true;
      }
      else if(this.scopeFromId == null && this.scopeToId == null) {
        this.scopeFromId = (this.lastBook <= 1)? 0 : (this.lastBook-1)*1000;
        this.scopeToId = this.lastBook*1000 + this.lastIndex;
      }
      else if(this.scopeFromId == null && this.scopeToId != null ) {
        this.scopeFromId = Math.max(0, Math.floor(this.scopeToId/1000)*1000);
      }
      else if(this.scopeToId == null && this.scopeFromId != null ) {
        this.scopeToId = Math.min(this.pageSensor.lastBook*1000 + this.lastIndex, Math.floor(this.scopeFromId/1000)*1000 + 999);
      }

      // this.scopeFromId = (this.lastBook <= 1)? 0 : (this.lastBook-1)*1000;

      // this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;

      // this.scopeToId = this.lastBook*1000 + this.lastIndex;

      // this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;

    },

    setAppHeight: function(height, overflowY) {
      /*
        pHeight: { type: String, default: "" },
        pOverflowY: { type: String, default: "" },
      */
      if(height) {
        if(this.isLastCharNumber(height)) {
          this.el("app").style.height = height + "px";
        }
        else {
          this.el("app").style.height = height;
        }
        if(overflowY) {
          this.el("app").style.overflowY = overflowY;
        }
      }
    },

    initDefaultValues: function() {
      /*
      pPresentation: { type: Boolean, default: false },
      pEditControl: { type: Boolean, default: true },
      pScopeControl: { type: Boolean, default: true },
      pSubControl: { type: Boolean, default: true },
      */

      if(this.pPresentation===true) {
        this.showPresentationModeEscapeButton = false;
        this.presentationMode = true;
      }
      if(this.pScopeControl===false) {
        this.showScopeControl = false;
      }
      if(this.pSubControl===false) {
        this.showSubControl = false;
      }

      /*
      pGroupBy: { type: String, default: "" },
      */
      if(this.pGroupBy !="" && this.pGroupBy != "default") {
        this.groupBy = this.pGroupBy;
      }
    },


    init: function() {

      this.initDefaultValues();
      this.setAppHeight(this.pHeight, this.pOverflowY);

      this.valuesFiltered = this.pageSensor.values.filter(element => {
        return !element.hold
      });
      this.valuesFiltered.forEach((item,index) => {
        this.valuesFilteredIndex[item.name] = index;
        this.valuesFilteredList[item.name] = item;
      });

      this.lastBook = this.pageSensor.lastBook;
      this.lastIndex = this.pageSensor.lastIndex;
      this.lastValuesModified = (this.pageSensor.lastValuesModified == null)? null : this.pageSensor.lastValuesModified.toDate();
      this.lastValues = this.pageSensor.lastValues;
      this.bookInfo = this.pageSensor.bookInfo;

      this.initScope();

      this.updateSliderValues();
      this.updateStep();

      this.initColumnsOptions();
      this.initColumns();

    },

    updateSliderValues: function() {
      if(this.scopeToId > this.scopeFromId) {
        if(this.sliderValues.length == 0) {
          this.sliderValues.push(Math.floor(this.scopeFromId/1000)*1000 -1);
          this.sliderValues.push((this.scopeToId == (this.sensorRowCount-1))? this.scopeToId : (Math.floor(this.scopeToId/1000)+1)*1000-1);
        }
        else if(this.sliderValues.length == 2) {
          this.$set(this.sliderValues, 0, Math.floor(this.scopeFromId/1000)*1000 -1);
          this.$set(this.sliderValues, 1, (this.scopeToId == (this.sensorRowCount-1))? this.scopeToId : (Math.floor(this.scopeToId/1000)+1)*1000-1);
        }
      }
    },

    updateStep: function() {
      let result = [];
      let maxBook = Math.floor(this.rowCount/1000);
      for(let i=0;i<=maxBook;i++) {
        result.push(i*1000-1);
      }
      result.push(this.rowCount-1);
      this.sliderStep = result;
    },

    initColumnsOptions: function() {


      this.valuesFiltered.forEach((value,index)=> {
        this.columnsOptions.default[value.name] = {
          "text": value.title,
          "index": index,
        };
        this.columnsOptions.hour[value.name] = {};
        this.columnsOptions.date[value.name] = {};
        this.columnsOptions.month[value.name] = {};
        this.typeOptions.forEach((type, typeIndex)=> {
          ["hour", "date", "month"].forEach(groupBy => {
            this.columnsOptions[groupBy][value.name][type.value] = {
              "text": type.text,
              "fullText": this.columnsOptions.default[value.name].text + ": " + type.text,
              "index": index,
              "typeIndex": typeIndex,
            };
          });
        });
      });
    },


    initColumns: function() {

      if(this.pColumns != "") {
        if(this.groupBy == "default") {
          let pColumns = this.pColumns.split(/[\s+]+/);
          pColumns.forEach(column => {
            if(typeof(this.valuesFilteredIndex[column]) != "undefined") {
              this.columns.default.push(column);
              this.columns.hour[column] = [this.typeOptions[0].value];
              this.columns.date[column] = [this.typeOptions[0].value];
              this.columns.month[column] = [this.typeOptions[0].value];
            }
          });
          this.valuesFiltered.forEach(item=> {
            if(typeof(this.columns.hour[item.name]) == "undefined") {
              this.columns.hour[item.name] = [];
              this.columns.date[item.name] = [];
              this.columns.month[item.name] = [];
            }
          })
        }
        else {
          let pColumns = this.pColumns.split(/[\s+]+/);
          pColumns.forEach(column=> {
            let splited = column.split(".");
            if(splited.length == 1) {
              splited.push(this.typeOptions[0].value);
            }
            if(splited.length == 2) {
              if(typeof(this.valuesFilteredIndex[splited[0]]) != "undefined" && typeof(this.valueTypeList[splited[1]]) != "undefined") {
                if(splited[1] == "all") {
                  this.columns.hour[splited[0]] = [];
                  this.typeOptions.forEach(item=> {
                    this.columns.hour[splited[0]].push(item.value);
                  });
                }
                else {
                  if(typeof(this.columns.hour[splited[0]]) == "undefined") {
                    this.columns.hour[splited[0]] = [splited[1]];
                    this.columns.date[splited[0]] = [splited[1]];
                    this.columns.month[splited[0]] = [splited[1]];
                  }
                  else {
                    if(!this.columns.hour[splited[0]].some(item => {
                      return item == splited[1]
                    })) {
                      this.columns.hour[splited[0]].push(splited[1]);
                      this.columns.date[splited[0]].push(splited[1]);
                      this.columns.month[splited[0]].push(splited[1]);
                    }
                  }
                }
                if(!this.columns.default.some(item=> {
                  return item == splited[0]
                })) {
                  this.columns.default.push(splited[0]);
                }
              }
            }
          });

          this.valuesFiltered.forEach(item=> {
            if(typeof(this.columns.hour[item.name]) == "undefined") {
              this.columns.hour[item.name] = [];
              this.columns.date[item.name] = [];
              this.columns.month[item.name] = [];
            }
          })
        }
      }
      else {
        this.valuesFiltered.forEach((value,index)=> {
          if(index==0) {
            this.columns.default.push(value.name);
          }
          this.columns.hour[value.name] = [this.typeOptions[0].value];
          this.columns.date[value.name] = [this.typeOptions[0].value];
          this.columns.month[value.name] = [this.typeOptions[0].value];
        });
      }
    },

    applySliderValues: function() {
      this.getData();
    },

    getData: function(forced = false) {

      this.tinkOptions._tinkDataReady = false;

      if(this.scopeFromId != null && this.scopeToId != null) {
        if(forced || this.oldScopeFromId == null || this.oldScopeToId == null || this.scopeFromId < this.oldScopeFromIdStart || this.scopeToId > this.oldScopeToIdEnd) {

          let firstBook = Math.floor(this.scopeFromId/1000);
          let lastBook = Math.floor(this.scopeToId/1000);
          let toRequest = [];
          for(let i=firstBook;i<=lastBook;i++) {
            if(typeof(this.$parent.$parent.pageSensorHistory[i]) == "undefined"|| this.$parent.$parent.pageSensorHistory[i].dirty) {
              toRequest.push(i);
            }
          }
          if(toRequest.length != 0) {
            let successCount = 0
            toRequest.forEach((item) => {
              db.collection("sensors").doc(this.pageSensor.id).collection("history").doc(item+ "")
              .get()
              .then(book => {
                if(book.exists) {
                  this.pageSensorHistory[item] = {
                    dirty: false,
                    data: book.data()
                  };
                  if(++successCount == toRequest.length) {
                    this.processData(forced);
                  }
                }
                else {
                  if(item == 0) this.makeToast("info", "데이터 조회중", "데이터가 없습니다.");
                  else this.makeToast("info", "데이터 조회중", item + "번 묶음 데이터가 없습니다.");
                }
              })
            })
          }
          else {
            this.processData(forced);
          }
        }
        else {
          this.processData(forced);
        }
      }
    },

    processData: function(forced = false) {

      this.tinkOptions._tinkDataReady = false;

      if(this.scopeFromDateSelected) {
        if(typeof(this.$parent.$parent.pageSensorHistory[this.scopeFromIdBook]) != "undefined") {
          let found = null;
          let endIndex = (this.scopeFromIdBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999;
          for(let startIndex = this.scopeFromId%1000;startIndex<=endIndex;startIndex++) {
            if(this.scopeFromDateEpochSeconds <= this.$parent.$parent.pageSensorHistory[this.scopeFromIdBook].data[startIndex].t.seconds) {
              found = startIndex;
              break;
            }
          }
          if(found != null) {
            this.scopeFromId = (this.scopeFromIdBook*1000)+found ;
            this.scopeFromDateSelected = false;
            this.scopeFromDate = this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000));
          }
        }
      }

      if(this.scopeToDateSelected) {
        if(typeof(this.$parent.$parent.pageSensorHistory[this.scopeToIdBook]) != "undefined") {
          let found = null;

          let startIndex = this.scopeToId%1000;

          for(let endIndex = (this.scopeToIdBook == this.pageSensor.lastBook)? this.pageSensor.lastIndex: 999; endIndex>= 0;endIndex--) {
            if(this.scopeToDateEpochSeconds <= this.$parent.$parent.pageSensorHistory[this.scopeToIdBook].data[endIndex].t.seconds) {
              found = endIndex;
            }
          }
          if(found != null) {
            this.scopeToId = (this.scopeToIdBook*1000) + found;
            this.scopeToDateSelected = false;
            this.scopeToDate = this.toISOString(new Date(this.scopeToIdEpochSeconds*1000));
          }
        }
      }

      let resetNeeded = (
        !forced &&
        this.oldScopeFromId != null &&
        this.oldScopeToId != null &&
        (this.oldScopeFromId < this.scopeToId) &&
        (this.oldScopeToId > this.scopeFromId) &&
        (
          (this.oldScopeToId - this.oldScopeFromId + 1) > 3000 &&
          ((Math.max(0, this.oldScopeFromId - this.scopeFromId) + Math.max(0, this.scopeToId - this.oldScopeToId)) < (this.oldScopeToId - this.oldScopeFromId + 1)/2)

          ||

          (this.oldScopeToId - this.oldScopeFromId + 1)>50000 &&
          ((Math.max(0, this.oldScopeFromId - this.scopeFromId) + Math.max(0, this.scopeToId - this.oldScopeToId)) < (this.oldScopeToId - this.oldScopeFromId + 1)/1.5)

          ||

          (this.oldScopeToId - this.oldScopeFromId + 1)>100000 &&
          ((Math.max(0, this.oldScopeFromId - this.scopeFromId) + Math.max(0, this.scopeToId - this.oldScopeToId)) < (this.oldScopeToId - this.oldScopeFromId + 1))
        )
      )? false: true;

      if(forced || resetNeeded) {
        this.initSensorData();
        this.resetTinkChartData();
        this.sensorData.forEach(item => {
          this.valuesFiltered.forEach((value, index)=> {
            this.tinkChartData.default[index].data.push({
              x: item.t.toDate().getTime(),
              y: item.v[index],
            });
          });
        });
      }
      else {
        let removeLeft = (this.scopeFromId > this.oldScopeFromId)? this.scopeFromId - this.oldScopeFromId : 0;
        let removeRight = (this.scopeToId < this.oldScopeToId)? this.oldScopeToId - this.scopeToId : 0;
        let toAddLeft = [];
        let toAddRight = [];
        // this.scopeFromId ~ (this.oldScopeFromId-1)
        if(this.scopeFromId < this.oldScopeFromId) {
          let toAddLeftEndBook = Math.floor((this.oldScopeFromId-1)/1000);
          for(let i=this.scopeFromIdBook;i<=toAddLeftEndBook;i++) {
            if(typeof(this.$parent.$parent.pageSensorHistory[i]) != "undefined") {
              let startIndex = (i == this.scopeFromIdBook)? this.scopeFromId%1000: 0;
              let endIndex = (i == toAddLeftEndBook)? (this.oldScopeFromId-1)%1000: (i == this.lastBook)? Math.min(this.pageSensor.lastIndex, endIndex) : 999;
              for(let j=startIndex;j<=endIndex;j++) {
                toAddLeft.push(this.$parent.$parent.pageSensorHistory[i].data[j]);
              }
            }
          }
        }
        // this.oldScopeFromId+1 ~ this.scopeToId
        if(this.scopeToId > this.oldScopdeToId) {
          let toAddRightStartBook = Math.floor((this.oldScopeFromId+1)/1000);
          for(let i=toAddRightStartBook;i<=this.scopeToIdBook;i++) {
            if(typeof(this.$parent.$parent.pageSensorHistory[i]) != "undefined") {
              let startIndex = (i == this.toAddRightStartBook)? (this.oldScopeFromId+1)%1000: 0;
              let endIndex = (i == this.scopeToIdBook)? (this.scopeToId)%1000: (i == this.lastBook)? Math.min(this.pageSensor.lastIndex, endIndex): 999 ;
              for(let j=startIndex;j<=endIndex;j++) {
                toAddRight.push(this.$parent.$parent.pageSensorHistory[i].data[j]);
              }
            }
          }
        }
        if(removeRight != 0) {
          this.sensorData.splice(this.sensorData.length - removeRight, removeRight);
          this.valuesFiltered.forEach((value, index)=> {
            this.tinkChartData.default[index].data.splice(this.tinkChartData.default[index].data.length - removeRight, removeRight);
          });
        }
        if(removeLeft != 0) {
          this.sensorData.splice(0, removeLeft);
          this.valuesFiltered.forEach((value, index)=> {
            this.tinkChartData.default[index].data.splice(0, removeLeft);
          });
        }
        if(toAddLeft.length != 0) {
          this.sensorData.unshift(...toAddLeft);
          this.valuesFiltered.forEach((value, index)=> {
            let toAddLeftData = [];
            toAddLeft.forEach(item => {
              toAddLeftData.push({
                x: item.t.toDate().getTime(),
                y: item.v[index],
              });
            });
            this.tinkChartData.default[index].data.unshift(...toAddLeftData);
          });
        }
        if(toAddRight.length != 0) {
          this.sensorData.push(...toAddRight);
          this.valuesFiltered.forEach((value, index)=> {
            let toAddRightData = [];
            toAddRight.forEach(item => {
              toAddRightData.push({
                x: item.t.toDate().getTime(),
                y: item.v[index],
              });
            });
            this.tinkChartData.default[index].data.push(...toAddRightData);
          });
        }
        this.resetTinkChartData("hour");
        this.resetTinkChartData("date");
        this.resetTinkChartData("month");
      }

      if(this.groupBy == "default") {
        if((this.scopeToId - this.scopeFromId) > this.tinkOptions._tinkGroupByAutoApplyLength) {
          this.groupBy = "hour";
        }
      }

      if(this.groupBy != "default") {
        this.makeGroupByData(this.groupBy);
        this.checkPerformanceChartOptions();
      }
      else {
        this.checkPerformanceChartOptions();
      }

      this.oldScopeFromId = this.scopeFromId;
      this.oldScopeToId = this.scopeToId;
      this.tinkChart.config.data.datasets = this.tinkChartData[this.groupBy];
      this.tinkOptions._tinkDataReady = true;
      this.resetZoom();
      this.initChartScales();
      this.applySelectedVisible();
      this.initCanvasContainer(false);
      (this.tinkOptions.animation !== false && this.tinkOptions.animation.duration == 0)? this.tinkChart.update(0) : this.tinkChart.update();

      // this.$log.info(this.tinkChart.scales.x.min, this.tinkChart.scales.x.max);
      this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXMax = this.tinkChart.scales.x.max;
      this.tinkOptions._tinkScaleXOriginalMin = this.tinkChart.scales.x.min;
      this.tinkOptions._tinkScaleXOriginalMax = this.tinkChart.scales.x.max;
      this.setZoomScaleMinMax();

      if(!this.drawOnce && this.pXMin != null && this.pXMax != null) {
        window.setTimeout(() => {
          this.tinkChart.zoomScale('x', {min: this.pXMin, max: this.pXMax}, 'default');
          this.tinkOptions._tinkScaleXMin = this.pXMin;
          this.tinkOptions._tinkScaleXMax = this.pXMax;
          this.drawOnce = true;
        }, 1000);
      }

      // this.$log.info("tinkChart", this.tinkChart);
    },

    checkSliderValues: function(evt) {
      if(evt[0] < evt[1]) {
        let newValue = [evt[0], evt[1]];

        if(newValue[1] > this.rowCount) {
          newValue[1] = (this.rowCount -1);
        }
        else if(newValue[1] > this.lastBook*1000) {
          newValue[1] = (this.rowCount -1);
        }

        if((newValue[0]%1000) != 999) {
          newValue[0] = -1;
        }
        if(newValue[0] == newValue[1]) {
          newValue[1] = Math.min(newValue[0]+1000, this.rowCount-1);
        }

        if(newValue[0] != evt[0] || newValue[1] != evt[1]) {
          this.sliderValues = newValue;
          this.$set(this.sliderValues, 0, newValue[0]);
          this.$set(this.sliderValues, 1, newValue[1]);
        }
        this.scopeFromId = newValue[0] + 1;
        this.scopeFromDate = (this.scopeFromIdEpochSeconds != null)? this.toISOString(new Date(this.scopeFromIdEpochSeconds*1000)) : null;
        this.scopeToId = newValue[1];
        this.scopeToDate = (this.scopeToIdEpochSeconds != null)? this.toISOString(new Date(this.scopeToIdEpochSeconds*1000)) : null;
      }
    },

    getLabel: function(value) {
      if(this.sliderStep.length > 20) {
        if(((value+1)/1000)%this.showLabelPer == 0) {
          return ((value+1)%1000 == 0)? ((value+1)/1000).toLocaleString("ko-KR") + "K" : value.toLocaleString("ko-KR");
        }
        else {
          return "";
        }
      }
      else {
        return (value == (this.pageSensor.lastBook*1000+this.pageSensor.lastIndex))? value.toLocaleString("ko-KR") : (value+1).toLocaleString("ko-KR");
      }
    },

    getDateRow: function(value) {
      if(this.sliderValues.length != 2) return "";
      else if(this.lastValues == null) return "";
      // lastItem
      else if(value == (this.pageSensor.lastBook*1000+this.pageSensor.lastIndex) && this.sliderEndStepShow) {
        return this.dateToString(this.lastValues.t.toDate(), "/", "\n", ":");
      }
      // ~ value(999)
      else if(value == this.sliderValues[1]) {
        let book = parseInt(value/1000);
        let bookInfoLength = this.countAttributes(this.bookInfo);
        if(book<bookInfoLength) return this.dateToString(this.bookInfo[book].to.toDate(), "/", "\n", ":");
      }
      // value(999)~
      else {
        let book = parseInt((value+1)/1000);
        let bookInfoLength = this.countAttributes(this.bookInfo);
        if(book<bookInfoLength) return this.dateToString(this.bookInfo[book].from.toDate(), "/", "\n", ":");
      }
      return "";
    },
    ...mapActions(['storeSaveChartOptions']),
  },

  computed: {

    fullURL: function() {

      let result = window.location.protocol;
      result += "//";
      result += window.location.host;
      result += window.location.pathname;
      result += "?mode=graph&pFromId=" + this.scopeFromId;
      if(this.scopeToId != (this.sensorRowCount-1)) {
        result += "&pToId=" + this.scopeToId;
      }
      result += "&pPresentation=" + ((this.presentationMode)?1:0);
      result += "&pScopeControl=1";
      result += "&pSubControl=1";
      // result += "&pPageControl=1";
      result += "&pHeight=";
      result += "&pOverflowY=";
      result += "&pGroupBy=" + this.groupBy;
      result += "&pXMin=" + Math.floor(this.tinkOptions._tinkScaleXMin);
      result += "&pXMax=" + Math.floor(this.tinkOptions._tinkScaleXMax);

      // this.tinkOptions._tinkScaleXMin = this.tinkChart.scales.x.min;
      // http://localhost:8080/s/9Vmfsdr2fLKElJnLbWNF?mode=graph&pFromId=44000&pToId=44999&pPresentation=0&pScopeControl=1&pSubControl=1&pHeight=&pOverflowY=&pGroupBy=hour&pXMin=1623024000000&xMax=1623142800000&pColumns=temp.average%2Bbaro.average%2Bhumi.average

      // http://localhost:8080/s/9Vmfsdr2fLKElJnLbWNF?mode=graph&pFromId=44000&pToId=44999&pPresentation=0&pScopeControl=1&pSubControl=1&pHeight=&pOverflowY=&pGroupBy=hour&xMin=1623090867242.476&xMax=1623109161158.1887&pColumns=temp.average%2Bbaro.average%2Bhumi.average
      if(this.groupBy=="default") {
        result+= "&pColumns=" + encodeURIComponent(this.columns.default.join("+"));
      }
      else {
        let tempStr = "";
        for(let valueName in this.columns[this.groupBy]) {
          this.columns[this.groupBy][valueName].forEach(typeName => {
            if(tempStr != "") tempStr += "+";
            tempStr += valueName + "." + typeName;
          })
        }
        if(tempStr != "") result += "&pColumns=" + encodeURIComponent(tempStr);
      }


      // result += "&pPerPage=" + this.perPage;
      // result += "&pCurrent=" + this.currentPage;
      // result += "&pSortBy=" + encodeURIComponent(this.sortBy);
      // result += "&pSortDesc=" + ((this.sortDesc)?1:0);
      return result;
    },


    canvasBoxStyle: function() {
      let result = "";
      if(this.tinkOptions) {
        result += "background-color:" + this.tinkOptions._tinkBackgroundColor +";";
        result += "padding:" + this.tinkOptions._tinkCanvasMargin +"px !important;";
      }
      return result;
    },

    zoomLevel: function() {

      if(this.tinkOptions._tinkScaleXMin != null && this.tinkOptions._tinkScaleXMax != null && this.tinkOptions._tinkScaleXOriginalMin != null && this.tinkOptions._tinkScaleXOriginalMax != null) {
        return (this.tinkOptions._tinkScaleXMax - this.tinkOptions._tinkScaleXMin)/(this.tinkOptions._tinkScaleXOriginalMax - this.tinkOptions._tinkScaleXOriginalMin);
      }
      else {
        return null;
      }
    },
    scaleXOriginalSize: function() {
      if(this.tinkOptions._tinkScaleXOriginalMin != null && this.tinkOptions._tinkScaleXOriginalMax != null) {
        return this.tinkOptions._tinkScaleXOriginalMax - this.tinkOptions._tinkScaleXOriginalMin;
      }
      else {
        return null;
      }
    },
    scaleXSize: function() {
      if(this.tinkOptions._tinkScaleXMin != null && this.tinkOptions._tinkScaleXMax != null) {
        return this.tinkOptions._tinkScaleXMax - this.tinkOptions._tinkScaleXMin;
      }
      else {
        return null;
      }
    },
    minFromDate: function() {
      return (this.pageSensor.bookInfo["0"])? this.toISOString(this.pageSensor.bookInfo["0"].from.toDate()): this.toISOString(new Date(1));
    },
    maxFromDate: function() {
      if(this.pageSensor.bookInfo[this.pageSensor.lastBook +""]) {
        if(this.scopeToIdEpochSeconds) {
          return this.toISOString(new Date(Math.min(this.scopeToIdEpochSeconds, this.pageSensor.bookInfo[this.pageSensor.lastBook +""].from.seconds)*1000));
        }
        else {
          return this.toISOString(this.pageSensor.bookInfo[this.pageSensor.lastBook +""].to.toDate());
        }
      }
      else {
        return this.toISOString(new Date(1));
      }
    },

    minToDate: function() {
      if(this.pageSensor.bookInfo["0"]) {
        return (this.scopeFromIdEpochSeconds)? this.toISOString(new Date(Math.max(this.scopeFromIdEpochSeconds, this.pageSensor.bookInfo["0"].from.seconds)*1000)) : this.toISOString(this.pageSensor.bookInfo["0"].from.toDate());
      }
      else {
        return this.toISOString(new Date(0));
      }
    },

    maxToDate: function() {
      return (this.pageSensor.bookInfo[this.pageSensor.lastBook +""])? this.toISOString(this.pageSensor.bookInfo[this.pageSensor.lastBook +""].to.toDate()) : this.toISOString(new Date(0));
    },

    dataUpdateNeeded: function() {
      if(this.scopeFromId == null) {
        return false;
      }
      else if(this.scopeToId == null) {
        return false;
      }
      else if(this.scopeFromId < 0) {
        return false;
      }
      else if(this.scopeFromId > Math.min(this.sensorRowCount-1-1, this.scopeToId-1)) {
        return false;
      }
      else if(this.scopeToId < (this.scopdeToId*1+1)) {
        return false;
      }
      else if(this.scopeToId > (this.sensorRowCount-1)) {
        return false;
      }
      else if(this.scopeFromDateSelected) {
        return true;
      }
      else if(this.scopeToDateSelected) {
        return true;
      }
      else if(this.scopeFromId == this.oldScopeFromId && this.scopeToId == this.oldScopeToId) {
        return false;
      }
      else {
        return true;
      }
    },
    showLabelPer: function() {
      return Math.floor(this.sliderStep.length/((window.innerWidth>1200)?40:20));
    },
    tinkChartConfig: function() {
      return {
        type: this.tinkOptions._tinkChartType,
        data: {
          datasets: this.tinkChartData[this.groupBy]
        },
        options: this.tinkOptions
      }
    },

    scopeToDateStr: function() {
      return (this.scopeToId == null || this.scopeToIdEpochSeconds == null)? "": this.dateToString(new Date(this.scopeToIdEpochSeconds*1000));
    },

    scopeToIdDateStr: function() {
      if(this.scopeToId == null || this.scopeToIdEpochSeconds == null) return "";
      else {
        return this.dateToString(new Date(this.scopeToIdEpochSeconds*1000));
      }
    },

    scopeToDateEpochSeconds: function() {
      if(this.scopeToDate == null || this.scopeToDate == "") return null;
      else return Math.floor((new Date(this.scopeToDate)).getTime()/1000);
    },

    scopeToIdEpochSeconds: function() {
      if(this.scopeToId == null) return null;
      if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+ Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)]) != "undefined") {
        return this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeToId/1000)].data["" + (this.scopeToId%1000)].t.seconds;
      }
      else {
        if(this.scopeToId == this.scopeToIdEnd) {
          if(typeof(this.pageSensor.bookInfo[this.scopeToIdBook]) != "undefined") {
            return this.pageSensor.bookInfo[this.scopeToIdBook].to.seconds;
          }
        }
      }
      return null;
    },

    scopeToIdBook: function() {
      if(this.scopeToId == null) return null;
      else return Math.floor(this.scopeToId/1000);
    },

    scopeFromIdDateStr: function() {
      return (this.scopeFromId == null || this.scopeFromIdEpochSeconds == null)? "" : this.dateToString(new Date(this.scopeFromIdEpochSeconds*1000));
    },

    scopeFromDateStr: function() {
      return (this.scopeFromDate == null || this.scopeFromDate == "")? "": this.dateToString((new Date(this.scopeFromDate)));
    },

    scopeFromDateEpochSeconds: function() {
      if(this.scopeFromDate == null || this.scopeFromDate == "") return null;
      else return Math.floor((new Date(this.scopeFromDate)).getTime()/1000);
    },

    scopeFromIdEpochSeconds: function() {
      if(this.scopeFromId == null) return null;

      if(typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)]) != "undefined" && typeof(this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)]) != "undefined") {
        return this.$parent.$parent.pageSensorHistory[""+Math.floor(this.scopeFromId/1000)].data["" + (this.scopeFromId%1000)].t.seconds;
      }
      else {
        if(this.scopeFromId == this.scopeFromIdStart) {
          if(typeof(this.pageSensor.bookInfo[this.scopeFromIdBook]) != "undefined") {
            return this.pageSensor.bookInfo[this.scopeFromIdBook].from.seconds;
          }
        }
      }
      return null;
    },

    scopeToIdStart: function() {
      if(this.scopeToId == null) return null;
      else return Math.floor(this.scopeToId/1000)*1000;
    },

    scopeToIdEnd: function() {
      if(this.scopeToId == null) return null;
      else return Math.min(Math.floor(this.scopeToId/1000)*1000+999, this.sensorRowCount - 1);
    },

    scopeFromIdStart: function() {
      if(this.scopeFromId == null) return null;
      else return Math.floor(this.scopeFromId/1000)*1000;
    },

    scopeFromIdEnd: function() {
      if(this.scopeFromId == null) return null;
      else return Math.min(Math.floor(this.scopeFromId/1000)*1000+999, this.sensorRowCount - 1);
    },

    scopeFromIdBook: function() {
      if(this.scopeFromId == null) return null;
      else return Math.floor(this.scopeFromId/1000);
    },

    oldScopeToIdEnd: function() {
      if(this.oldScopeToId == null) return null;
      else return Math.min(Math.floor(this.oldScopeToId/1000)*1000+999, this.sensorRowCount - 1);
    },

    oldScopeToIdBook: function() {
      if(this.oldScopeToId == null) return null;
      else return Math.floor(this.oldScopeToId/1000);
    },

    oldScopeFromIdStart: function() {
      if(this.oldScopeFromId == null) return null;
      else return Math.floor(this.oldScopeFromId/1000)*1000;
    },

    oldScopeFromIdBook: function() {
      if(this.oldScopeFromId == null) return null;
      else return Math.floor(this.oldScopeFromId/1000);
    },

    sensorValuesMap: function() {
        var result = {}
        this.pageSensor.values.forEach(val=> {
          result[val.name] = val
        })
        return result
    },
    chartHeight: function() {
      return this.showHeight - 300
    },
    sensorValuesIndexMap: function() {
        var result = {}
        var j = 0
        for(var i=0;i<this.pageSensor.values.length;i++) {
          if(!this.pageSensor.values[i].hold) {
            result[this.pageSensor.values[i].name] = j
            j++
          }
        }
        return result
    },
    rowCount: function() {
      return this.lastBook*1000 + this.lastIndex + 1;
    },

    sensorRowCount: function() {
      return this.pageSensor.lastBook*1000 + this.pageSensor.lastIndex + 1;
    },

    sliderValuesString: function() {
      if(this.sliderValues.length == 2) {
        return (this.sliderValues[0]+1) + "~" + this.sliderValues[1];
      }
      else {
        return "";
      }
    },
  },

  watch: {
    presentationMode: function() {
      this.initCanvasContainer(true);
    }
  }

}
</script>
